// 韩国
export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: '대출금',
        Bo2: '비즈니스 기회와 금융 상품 탐색을 도와드립니다',
        Bo3: '대출금 규칙',
        Bo4: '경우',
        Bo5: '상환 기한 내: 고정 금리',
        Bo6: '기간 중 미납 금액에 대해서는 매일 비용이 청구됩니다',
        Bo7: '벌금. 대출 전 상환 능력에 주의하세요. 불필요한 추가 비용을 피하기 위해서입니다.',
        Bo8: '취소',
        Bo9: '확인',
        Bo10: '상환',
        Bo11: '주의: 예금 주소와 상환 주소는 다르므로, 잘못되지 않도록 올바른 주소로 상환해야 합니다.',
        Bo12: '지갑 주소:',
        Bo13: '변경 거부',
        Bo14: '거부 사유:',
        Bo15: '편집 계속하기',
        Bo16: '전송 성공, 담당자가 24시간 이내에 대출 요청을 검토하니 주의해 주세요',
        Bo17: '승인 - 허용된 한도액',
        Bo18: '암호 계좌에서 확인할 수 있습니다',
        Bo19: '대출 일수',
        Bo20: '지급',
        Bo21: '이자 포함',
        Bo22: '원클릭 지급',
        Bo23: '대출 정보',
        Bo24: '은행 이름',
        Bo25: '은행 계좌 번호',
        Bo26: '희망 대출 금액',
        Bo27: '신원 확인 서류',
        Bo28: '신분증 앞면과 뒷면',
        Bo29: '업로드하려면 클릭',
        Bo30: '이름',
        Bo31: '휴대전화 번호',
        Bo32: '신분증 번호',
        Bo33: '영주지 주소',
        Bo34: '현재 주소',
        Bo35: '보증인 정보 증명',
        Bo36: '보증인 이름',
        Bo37: '연락처 번호',
        Bo38: '고객과의 관계',
        Bo39: '거주지',
        Bo40: '수입 증명 (급여 명세서, 회사 증명서 등 업로드)',
        Bo41: '수입 증명',
        Bo42: '소유 증명 (토지 증명서, 차량 증명서, 예금 증명서 등)',
        Bo43: '소유 증명',
        Bo44: '기타 서류',
        Bo45: '대출 관련 서류를 제출',
        Bo46: '신원 확인 서류의 앞면과 뒷면을 업로드하세요',
        Bo47: '수입 증명을 업로드하세요',
        Bo48: '소유 증명을 업로드하세요',
        Bo49: '대출 이용자',
        Bo50: '상환 목록',
        Bo51: '통화를 빌리는 것은 위험이 있으며, 최종 결과는 실제 심사에 따라 달라집니다',
        Bo52: '왜 통화를 빌리는 것을 선택하나요?',
        Bo53: '빠른 승인, 투명한 수수료',
        Bo54: '통화를 빌리고 싶은 은행을 선택해 주세요',
        Bo55: '은행 직대출, 담보 불필요',
        Bo56: '역사적인',
        Bo57: '메모리 단어',
        Bo58: '메모리 단어는 앱 로그인에 사용할 수 있습니다',
        Bo59: '생성',
        Bo60: '보기',
        Bo61: '복사',
        Bo62: '유감입니다',
        Bo63: '낙심하지 마세요, 전략을 조정하고 다시 도전하세요!',
        Bo64: '축하합니다',
        Bo65: '좋은 징조입니다! 상태를 유지하고 더 큰 성과를 거두세요',
        Bo66: '계속 주문',
        Bo67: '자금의 안전을 보장하기 위해 상환 시 다음 사항에 특별히 주의하십시오:',
        Bo68: '1. 플랫폼에서 제공하는 공식 상환 주소만 사용하십시오. 플랫폼의 공식 채널 이외의 출처에서 얻은 상환 주소는 무효합니다.',
        Bo69: '2. 사기 주의: 누군가가 개인적으로 연락하여 소위 상환 주소를 제공하는 경우 쉽게 믿지 마십시오.',
        Bo70: '3. 자금 안전 책임: 잘못된 상환 주소 사용으로 인해 자금이 손실된 경우 플랫폼은 책임지지 않으며 법에 따라 관련 법적 책임을 추구할 수 있습니다.',
        Bo71: '경계심을 유지하고 공식 채널을 통해 상환 작업을 수행하여 재산 안전을 효과적으로 보호하십시오!',
        Bo72: '보안 알림',
        Bo73: '알겠습니다',
        Bo74: '귀하의 현재 계정은 가상 계정이며, 계정 내의 모든 자금은 시뮬레이션 거래에만 사용되며 실제 인출 작업에 사용할 수 없습니다. 경계를 유지하고 관련 위험에 대비하세요!',

    },
    Purchase: {
        Pu1: '구매',

        Pu2: '지불 선택',

        Pu3: '결제 방법 선택',

        Pu4: '주문 확인',

        Pu5: '도착',

        Pu6: '잔액',

        Pu7: '매입 수량을 입력하세요',

        Pu8: '금액을 입력하세요',

        Pu9: '매출 수량을 입력하십시오',

        Pu10: '모두',

        Pu11: '최소는 작으면 안 됨',

        Pu12: '최대는 클 수 없음',

        Pu13: '참조 가격',

        Pu14: '수수료',

        Pu15: '즉시 구매',

        Pu16: '즉시 판매',

        Pu17: '사자',

        Pu18: '매',

        Pu19: '결제 방법 선택',

        Pu20: '결제 방법',

        Pu21: '지불 방법 추가',

        Pu22: '추가',

        Pu23: '사용자 이름',

        Pu24: '은행카드번호',

        Pu25: 'IFSC code',

        Pu26: '핸드폰 번호',

        Pu27: '확인',

        Pu28: '주문 확인',

        Pu29: '예!',

        Pu30: '당신은 성공적으로 돈을 인출했습니다',

        Pu31: '상태',

        Pu32: '완료',

        Pu33: '받은 금액',

        Pu34: '사자',

        Pu35: '매도',

        Pu36: '코인 이름',

        Pu37: '거래 총액',

        Pu38: '수',

        Pu39: '가격',

        Pu40: '상태',

        Pu41: '시간',

        Pu42: '가격',

        Pu43: '성공',

        Pu44: '실패',

        Pu45: '처리 중',

        Pu46: '유통기한',

        Pu47: '기각',

        Pu48: '끝',
        Pu49: '공식 홈페이지',
        Pu50: '백서',
        Pu51: '소개',
        Pu52: '공식 홈페이지 링크',
    },
    nhome: {
        Nh1: '세계에서 가장 큰 암호화폐 거래소 중 하나는 신뢰할 수 있는 플랫폼입니다',
        Nh2: '백만 명이 넘는 플랫폼 등록 사용자, 매일 1000000000USDT가 넘는 거래량이 지금 우리와 가입하여 거래 고수를 따라 투자 거래를 진행합니다',
        Nh3: '거래량',
        Nh4: '사용자',
        Nh5: '다양한 제품 서비스',
        Nh6: '– 더 많은 서비스를 선택하고 무한한 가능성을 탐색하세요',
        Nh7: '계약 거래',
        Nh8: '현물거래',
        Nh9: '옵션 거래',
        Nh10: '프랑스 화폐 거래',
        Nh11: '유동량이 가장 높고 선불 요율이 가장 낮으며 효율적이고 우수하며 절호의 유동성을 가진 화폐 항목',
        Nh12: '등 수백 개의 양질의 화폐를 제공하는 거래 서비스는 안전하고 신뢰할 수 있으며 시장 거래 비율이 가장 낮다',
        Nh13: '참여자 수가 가장 많고 게임 방법이 공평하고 공정하며 배상률이 높다',
        Nh14: '원클릭 바로 코인 구매는 효율적이고 편리한 실시간 거래 시스템을 제공합니다.당신의 자금 출입도 초당 초당 가능합니다.',
        Nh15: '인기 암호화폐',
        Nh16: '더 보기',
        Nh17: '우리의 강점',
        Nh18: '세계 최고의 보안 바람 제어 시스템 보유',
        Nh19: '사용자 자산의 전방위 보호',
        Nh20: '----신뢰할 수 있는 플랫폼입니다',
        Nh21: '오프라인 스토리지 모드',
        Nh22: '다중 요소 암호화',
        Nh23: '24*7일 플랫폼 모니터링',
        Nh24: '선도적인 디지털 자산 거래 플랫폼',
        Nh25: '– 다양한 거래 요구를 충족하는 풍부한 디지털 자산 거래 및 자산 관리 서비스',
        Nh26: '언제 어디서나 거래 시작',
        Nh27: 'IOS 및 Android 시스템 완전 지원',
        Nh28: 'QR코드 스캔 다운로드',
        Nh29: '상승폭 순위',
        Nh30: '낙폭 순위',
        Nh31: '거래액 순위',
        Nu32: '세계 최고의 디지털 자산 거래 플랫폼',
        Nu33: "- 다양한 거래 요구를 충족하는 풍부한 디지털 자산 거래 및 자산 관리 서비스",
        Nu34: '거래를 시작하고 최고의 암호화폐 여행을 경험하라',
        Nu35: '최소 5개 이상 길이',
        Nu36: '빠른 코인 구매',
        Nu37: '화폐 사기',
        Nu38: '1. 단일 300w-10억 IDR.',
        Nu39: '2. 결제 계좌를 받은 후에 규정된 시간 내에 이체를 완료하고 규정된 시간을 초과하면 고객센터에 연락해서 주문이 유효한지 확인하세요.',
        Nu40: '3. 계좌이체를 완료한 후 거래 계좌나 계좌 UID를 제공하고 상세한 계좌이체 캡처와 유효한 개인 증명서를 제공해 주십시오.',
        Nu41: '클릭은 이미 알고 있다'
    },
    common: {
        logins: '로그인 중...',
        login: '로그인',
        register: '등기',
        loginregister: "로그인 등록",
        logout: '로그 아웃',
        tip: '팁',
        logintip: '먼저 로그인하시기 바랍니다',
        expect: '계속 지켜봐주세요!',
        delete: '삭제를 확인 하시겠습니까?',
        nodata: '기록 없음',
        set: '설정',
        update: '수정',
        slogan: "세계 50 대 디지털 화폐 거래소",
        subslogan: "주 기관은 자산 보안을 보장합니다",
        more: "더",
        please: "제발 먼저",
        pleaseselect: "선택하세요",
        searchplaceholder: "검색 할 통화 명 입력",
        searchplaceholderswap: "검색 할 계약 이름 입력",
        loading: "로드 중 ...",
        close: "종료",
        ok: "결정",
        fillComplete: "완전한 정보를 입력하십시오"
    },
    header: {
        index: '집',
        exchange: '코인 화폐 거래',
        otc: '피아트 통화 OTC',
        kefu: '지원 센터',
        asset: '금융 센터',
        ucenter: '계정 센터',
        service: '발표',
        downloadapp: "코드를 스캔하여 다운로드 및 설치",
        appdownlaod: '앱 다운로드',
        usercenter: "개인 센터",
        helpcenter: "지원 센터",
        aboutus: "의 위에",
        partner: "파트너",
        bzb: "BZB",
        assetmanage: "자금 관리",
        trademanage: "거래 관리",
        activity: "최신 이벤트",
        lab: "혁신 연구소",
        ctc: "피아트 통화 C2C",
        labdetail: "BIPPAX Lab ● 혁신 성과 공유",
        invite: "프로모션 파트너",
        whitepaper: "백지",
        scandownload: "앱 다운로드",
        innovationmanage: "혁신 관리",
        swap1: "영구 계약",
        swap2: "영구 계약 (매칭)",
        swap3: "차액 계약",
        swap4: "두 번째 계약",
        cexchange: "빠른 교환",
        option: "옵션 계약",
        news: "뉴스",
        or1: '최신 가격',
        or2: '베팅 시간',
        or3: '베팅 금액',
        or4: '베팅 통화',
        or5: '기타 금액',
        or6: '현재 가격이 실행 가격임',
        or7: '거래 기록',
        or8: '배율',
        or9: '보너스',
        or10: '거래 기록',
        or11: '일반적인 USDT 베팅 금액 4개를 선택하세요',
    },
    sectionPage: {
        ptaqTitle: '플랫폼 보안',
        ptaqContent: '세계 최고의 보안 인증 인 해시 알고리즘 암호화 사용',
        ptslTitle: '플랫폼 강도',
        ptslContent: '세계 최대 비트 코인 거래 플랫폼',
        newsTitle: '멀티 터미널 앱',
        brandTitle: "BIPPAX 정보",
        brandDetail: "정직 | 공정성 | 열정 | 개방성",
        brandDesc1: "www.bippaxcoins.com은 초기 비트 코인 참가자 및 괴짜 그룹에 의해 설립되었습니다. 팀의 핵심 구성원은 Google, Microsoft, Alibaba, Tencent 등과 같은 잘 알려진 회사 출신으로, 깊은 R & D 강점과 인터넷 제품 운영에 대한 풍부한 경험을 가지고 있습니다.",
        brandDesc2: "www.bippaxcoins.com은 글로벌 사용자에게 고품질 암호화 자산 거래 플랫폼을 제공하기 위해 최선을 다하는 기본 블록 체인 서비스 제공 업체로 자리 매김하고 있으며,'악하지 말라' 라는 기본 원칙을 고수하며 고객에게 개방성을 제공하기 위해 정직, 공정성 및 열정을 주장합니다. 이러한 태도는 사용자의 기본적인 이익에 도움이되는 모든 파트너 / 프로젝트를 환영합니다. ",
        gettingstart: "시작하기 | 빠르게 코인 구매",
        officialstart: "BIPPAX 공식 초심자 입장 보조 채널",
        oneminutebuy: "통화 거래",
        oneminutebuytips: "하나의 디지털 자산을 사용하여 다른 자산으로 직접 교환",
        baseknow: "계약 거래",
        baseknowtips: "물물 교환 계약으로 T + 0 양방향 거래 가상 상품",
        baseexchange: "옵션 계약",
        baseexchangetips: "디지털 자산 파생 상품",
        usersocial: "빠른 교환",
        usersocialtips: "신속한 디지털 자산 교환",
        mainboard: "메인 보드 거래 지역",
        preview: "이전 페이지",
        nextpage: "다음 페이지",
        downloadwhite: '백서 다운로드 (또는 백서 오른쪽 클릭-> "다른 이름으로 저장 ...")'
    },
    nav: {
        shouye: '집',
        jiaoyi: '피아트 통화 거래',
        dingdan: '주문 관리',
        zijin: '금융 센터',
        yonghu: '사용자 센터',
        bibi: '코인 화폐 거래',
        fabu: '광고 게재',
        ptjy: '플랫폼 거래',
        ptaq: '플랫폼 보안',
        ptsl: '플랫폼 강도',
        xwzx: '멀티 터미널 앱'
    },
    progress: {
        already: "채광 한",
        total: "총 채굴량은 60 억 BHB입니다."
    },
    service: {
        USDT: 'USDT',
        BTC: 'BTC',
        ETH: 'ETH',
        CUSTOM: '선택 과목',
        COIN: '통화',
        favor: '수집',
        symbol: '거래 쌍',
        NewPrice: '최근 가격',
        ExchangeNum: '거래 수',
        Change: '24 시간 상하 ',
        OpenPrice: '개장 가격',
        PriceTrend: '가격 동향',
        Operate: '운영 중',
        Exchange: '무역을하다',
        trading: "지금 거래",
        high: "24 시간 최고가",
        low: "24 시간 최저 가격"
    },
    swapAssets: {
        Br1: '청약 반송',

        Br2: '구약 구매',

        Br3: "계약계좌로 이체",

        Br4: "계약계좌 이체",

        Br5: '영속계약 손익',

        Br6: '끝',

        Br7: "계약계정(U본위)",

        Br8: '지갑 잔액',

        Br9: '현재 가격',

        Br10: '개다',

        Br11: '비우기',

        Br12: '기타 계약 숨기기',

        Br13: '원클릭 평창',

        Br14: '모두 취소',
        Br15: '영구 계약 잔액 수정',
    },
    exchange: {
        wholehog: '최다매출',
        coin: '통화',
        symbol: "거래 쌍",
        lastprice: '최근 가격',
        daychange: '24 시간 상하 ',
        market: '시장',
        favorite: '수집',
        do_favorite: '모은',
        cancel_favorite: '좋지 않음',
        type: "유형",
        dealamount: "회전율",
        high: '높은',
        low: '낮은',
        vol: '24H 금액',
        buy: '구입',
        sell: '팔다',
        limited_price: '한정 가격',
        market_price: '시장 가격',
        fees_rate: '율',
        balance: '자산',
        or: '또는',
        starttrade: '거래 시작',
        canuse: '유효한',
        recharge: '충전',
        buyprice: '구매 가격',
        buynum: '볼륨 구매',
        amount: '거래 금액',
        buyin: '구입',
        disablebuyin: "시장 가격으로 구매 금지",
        buytip: '시장에서 가장 좋은 가격에 사다',
        sellprice: '판매 가격',
        sellnum: '판매 금액',
        sellout: '팔다',
        disablesellout: "시장 가격으로 판매 금지",
        selltip: '시장에서 가장 좋은 가격에 판매',
        curdelegation: '현재 커미션',
        hisdelegation: '위임 역사',
        realtransaction: '실시간 거래',
        num: '수량',
        price: '가격',
        direction: '방향',
        time: '시각',
        stall: '스톨',
        total: '총계',
        traded: '거래 완료',
        action: '운영 중',
        undo: '주문 취소',
        delegationnum: '수탁 금액',
        done: '거래 완료',
        status: '상태',
        finished: '완료',
        canceled: '취소 된',
        parted: "부분 거래",
        tip: '신속한',
        buyamounttip: '구매 금액을 입력하세요',
        buyamounttipwarning: '구매 수량은 다음보다 클 수 없습니다',
        success: '성공적으로 제출되었습니다',
        pricetip: '거래 금액을 입력하세요',
        pricetipwarning: '거래 금액은 다음보다 클 수 없습니다',
        sellamounttip: '판매 금액을 입력하세요',
        sellamounttipwarning: '판매 수량은 다음보다 클 수 없습니다.',
        sellpricetip: '판매 가격을 입력 해주세요',
        sellpricetipwarning: '판매 가격은 더 높을 수 없습니다',
        undotip: '주문을 취소 하시겠습니까? ',
        cancelsuccess: "주문이 성공적으로 취소되었습니다!",
        marketprice: '시장 가격',
        expand: {
            time: '시각',
            price: '가격',
            amount: '수량',
            fee: '수수료',
        },
        realtime: '시분할',
        kline: "K 라인 차트",
        depth: "깊이지도",
        publishstate0: "이벤트가 곧 시작됩니다. 잠시만 기다려주십시오 ...",
        publishstate1: "이벤트가 곧 종료됩니다. 최대한 빨리 거래 해주세요 ...",
        publishstate2: "활성 주문이 통합되고 있습니다. 잠시만 기다려주십시오 ...",
        publishstate3: "통합이 끝났습니다. 자유롭게 거래하세요 ...",
        publishdetail: "활동 규칙 세부 사항",
        publishprice: "발행 가격",
        publishamount: "합계",
        publishcounttxt0: "이벤트가 시작되기 전에 아직 남아 있습니다",
        publishcounttxt1: "이벤트가 끝날 때까지 남아있다",
        publishcounttxt2: "청산이 끝날 때까지 남아있다",
        publishcounttxt3: "이벤트가 끝났습니다",
        dateTimeDay: "일",
        dateTimeHour: "시각",
        dateTimeMinutes: "분",
        dateTimeSeconds: "둘째",
        moredetail: "자세한 내용은"
    },
    swap: {
        Sw1: '보증금 증액',
        Sw2: '보증금 줄이기',
        Sw3: '증가',
        Sw4: '감소',
        Sw5: '보증금',
        Sw6: '최대',
        Sw7: '이후의 강평 가격은',
        Sw8: '이후 레버 배수는',
        Sw10: '계약보증금 증액',
        Sw11: "계약 보증금 감소",
        Sw12: '설명 텍스트',
        Spsl1: '실제 트리거 시간',
        Spsl2: '실제 트리거 수',
        Spsl3: '실제 트리거 방향',
        Spsl4: '실제 트리거 가격',
        contract: "계약",
        swapindex: "지속 가능성",
        coin: '통화',
        symbol: "거래 쌍",
        volume: "음량",
        lastprice: '최근 가격',
        daychange: '24H 기복',
        market: '시장',
        favorite: '수집',
        do_favorite: '모은',
        cancel_favorite: '좋지 않음',
        type: "유형",
        dealamount: "회전율",
        high: '높은',
        low: '낮은',
        vol: '24H 금액',
        buy: '구입',
        sell: '팔다',
        limited_price: '제한 주문',
        market_price: '시장 주문',
        spot_price: '이익 중지 손실 중지',
        fees_rate: '율',
        balance: '자산',
        or: '또는',
        starttrade: '거래 시작',
        canuse: '유효한',
        recharge: '충전',
        buyprice: '구매 가격',
        buynum: '볼륨 구매',
        amount: '거래 금액',
        buyin: '구입',
        disablebuyin: "시장 가격으로 구매 금지",
        buytip: '시장에서 가장 좋은 가격에 사다',
        sellprice: '판매 가격',
        sellnum: '판매 금액',
        sellout: '팔다',
        disablesellout: "시장 가격으로 판매 금지",
        selltip: '시장에서 가장 좋은 가격에 판매',
        curdelegation: '현재 커미션',
        hisdelegation: '역사위원회',
        realtransaction: '실시간 거래',
        num: '수량',
        price: '가격',
        direction: '방향',
        time: '시각',
        stall: '스톨',
        total: '총계',
        traded: '거래 완료',
        action: '운영 중',
        undo: '주문 취소',
        delegationnum: '수탁 금액',
        done: '거래 완료',
        status: '상태',
        finished: '완료',
        canceled: '취소 된',
        parted: "부분 거래",
        tip: '신속한',
        buyamounttip: '구매 금액을 입력하세요',
        buyamounttipwarning: '구매 수량은 다음보다 클 수 없습니다',
        success: '성공적으로 제출되었습니다',
        pricetip: '거래 금액을 입력하세요',
        pricetipwarning: '거래 금액은 다음보다 클 수 없습니다',
        sellamounttip: '판매 금액을 입력하세요',
        sellamounttipwarning: '판매 수량은 다음보다 클 수 없습니다.',
        sellpricetip: '판매 가격을 입력 해주세요',
        sellpricetipwarning: '판매 가격은 더 높을 수 없습니다',
        undotip: '주문을 취소 하시겠습니까? ',
        cancelsuccess: "주문이 성공적으로 취소되었습니다!",
        marketprice: '시장 가격',
        expand: {
            time: '시각',
            price: '가격',
            amount: '수량',
            fee: '수수료',
        },
        realtime: '시분할',
        kline: "K 라인 차트",
        depth: "깊이지도",
        open: "오픈 포지션",
        close: "폐쇄 포지션",
        latestdeal: "최근 거래",
        myswapaccount: "내 계약 계정",
        accountmode: "계정 모드",
        accountmargin: "다중 계약",
        accountquanyi: "계정 총 자본",
        profitandloss: "미실현 이익 및 손실",
        principalAmount: "사용 가능한 마진",
        positionAmount: "포지션 여백",
        frozenAmount: "여백 고정",
        principalRate: "자금 활용률",
        zijinhuazhuan: "자금 이체",
        up: "많은",
        down: "빈",
        canup: "더 열 수 있습니다",
        candown: "비어 열 수 있음",
        cancloseup: "쇼트 포지션은 닫을 수 있습니다",
        canclosedown: "여러 위치를 닫을 수 있습니다.",
        openup: "오픈 매수",
        opendown: "매도 숏 오픈",
        closeup: "숏숏 구매",
        closedown: "플랫 이상 판매",
        currentposition: "현재 위치",
        assetsdetail: "자금 정보",
        marginMode1: "창고 별 섀시",
        marginMode2: "전체 창고",
        modifyMarginModeTitle: "계정 모드 수정",
        modifyLeverage: "다수 계약 조정",
        moredetail: "자세한 내용은",
        shareNumber: "장",
        entrustprice: "커미션 가격",
        triggleprice: "트리거 가격",
        openvolume: "열린 포지션 수",
        closevolume: "폐쇄 된 포지션의 수량",
        triggleplaceholder: "기본 커미션 가격은 시장 가격입니다",
        marketpriceplaceholder: "최상의 시장 가격에 판매",
        levmaxtip: "계약 배수는 최고 배수보다 높을 수 없습니다",
        levmintip: "계약 배수는 최소 배수보다 낮을 수 없습니다",
        marginModeSuccessTip: "계약 계정 모델이 성공적으로 수정되었습니다.",
        noenoughbalance: "계정 마진 부족",
        pleaseinputopenvolume: "개봉 수량은 0보다 커야합니다",
        pleaseinputcorrectopenvolume: "정확한 개봉 수량을 입력하십시오",
        pleaseinputrightentrustprice: "정확한 주문 가격을 입력하십시오",
        noenoughposition: "불충분 한 유동성 포지션",
        pleaseinputclosevolume: "마감 수량은 0보다 커야합니다.",
        pleaseinputcorrectclosevolume: "올바른 마감 수량을 입력하십시오",
        pos_Pl: "수입",
        pos_Ratio: "수익률",
        pos_pos: "위치",
        pos_canClose: "평균 금액",
        pos_openPrice: "평균 시가",
        pos_leverage: "다중 계약",
        pos_margin: "현재 증거금",
        pos_mRatio: "마진율",
        pos_cmRatio: "마진율 유지",
        pos_long: "긴",
        pos_short: "짧은",
        ent_entrustType: "오픈 포지션 / 마감 포지션",
        ent_direction: "방향",
        ent_type: "위임 유형",
        ent_trigglePrice: "트리거 가격",
        ent_entrustPrice: "커미션 가격",
        ent_tradedPrice: "최종 가격",
        ent_margin: "여유",
        ent_volume: "주문 수량",
        ent_status: "위임 상태",
        ent_status1: "시운전",
        ent_status2: "취소됨",
        ent_status3: "위임 실패",
        ent_status4: "위임 성공",
        ent_statusblast: "브레이크 아웃",
        ent_pl: "결산 손익",
        ent_fee: "수수료",
        triggerpriceshouldbigger: "트리거 가격은 0보다 커야합니다."
    },
    ctc: {
        title: "원 클릭 거래 ● 플랫폼 호스팅 ● 안전 및 보안",
        desc: "디지털 자산은 사용자 자산의 안전을 보장하기 위해 BIPPAX 플랫폼에서 관리합니다.",
        buyin: "구입",
        sell: "팔다",
        buyprice: "구매 가격",
        sellprice: "판매 가격",
        buynum: "구매 금액",
        sellnum: "판매 금액",
        payamount: "정산 합계",
        getamount: "정산 합계",
        avabalance: "사용 가능한 수량",
        time: "거래 시간",
        tip: "신속한",
        notice: "팁",
        notice1: "1. 법정 화폐 거래 영역은 사용자와 수락 자 간의 자산 거래를위한 것입니다. 자금은 플랫폼으로 이체되지 않으며 플랫폼은 RMB 재충전 / 송금을 허용하지 않습니다.",
        notice2: "2. 법정 화폐 거래 수락자는 실명 인증을 통과하고 거래 마진을 제공하며 토큰은 플랫폼에서 호스팅하므로 안심하고 교환 할 수 있습니다.",
        notice3: "3. 수락 자 서비스 시간은 매일 09입니다.",
        notice4: "4. 합법적 인 통화 거래 구역은 은행 카드를 지원하며, 송금시 실명 확인 계좌를 사용해야합니다.",
        notice5: "5. 거래 자금의 안전을 보장하기 위해 법정 화폐 거래는 사용자가 실명 인증을 거쳐야합니다. 실명 인증을 통과 한 후 펀드 비밀번호와 입금 계좌를 제때 설정 해주시면 거래가 불가능합니다.",
        payType: "결제 방법",
        receiveType: "결제 방법",
        moneyTips: "상기 금액은 참고 용입니다. 다음 주문 후 실제 결제 금액을 참고하세요.",
        verifyset: "실명 인증 / 자금 비밀번호",
        payset: "결제 / 영수증 설정",
        trade: "트랜잭션",
        input50tips: "50에서 50000 사이의 숫자를 입력하십시오",
        bank: "은행 카드",
        alipay: "알리 페이",
        wechatpay: "위챗",
        payaccountset: "결제 계정 설정",
        useselfaccount: "본인 실명 인증과 일치하는 추심 / 결제 계좌를 사용하세요",
        orderSn: "주문 번호",
        tradetime: "주문 시간",
        direction: "거래 유형",
        amount: "수량 (USDT)",
        money: "총액 (CNY)",
        price: "단가 (CNY)",
        status: "상태",
        operate: "운영 중",
        moredetail: "더 많은 거래 지침"
    },
    cexchange: {
        title: "BZB 활동 교환",
        desc: "BZB 플랫폼 화폐 ● 원 클릭 교환 ● 혜택 즐기기",
        quantity: "교환 수량",
        inputtips1: "사용자 지정 수량 입력",
        choosecurrency: "환전 통화 선택",
        all: "모두",
        totalpay: "총 교환 금액",
        restricted: "오늘의 한정판",
        currentprice: "현재 교환 가격",
        nextprice: "다음 교환 가격",
        confirmpay: "교환 확인",
        assets: "유효한:",
        loginFirst: "먼저 로그인하시기 바랍니다",
        success: "축하합니다! 교환이 성공했습니다!",
        tip: "신속한",
        confirmmsg: "확인"
    },
    subscribe: {
        Su1: '자세한 정보 페이지',

        Su2: '청약',

        Su3: '새 코인 구매',

        Su4: '시작할 때',

        Su5: '진행 중',

        Su6: '공개 예정',

        Su7: '거리',

        Su8: '시작',

        Su9: '발매 가격',

        Su10: '예상 손익률',

        Su11: '시작 시간',

        Su12: '공개 시간',

        Su13: '자세한 정보',

        Su14: '청약',

        Su15: '청약 요청',

        Su16: '코인 이름',

        Su17: '발행 가격',

        Su18: '발행 가격',

        Su19: '낙찰 수량',

        Su20: '환불 금액',

        Su21: '시간',

        Su22: '상태',

        Su23: '시간',

        Su24: '청약 금액',

        Su25: '청약 코인',

        Su26: '발매 가격',

        Su27: '예상 손익',

        Su28: '청약 상한',

        Su29: '청약 시작 시간',

        Su30: '청약 종료 시간',

        Su31: '결과 발표 시간',

        Su32: '출시 예정 시간',

        Su33: '청약금액',

        Su34: '통화',

        Su35: '청약 금액',

        Su36: '청약 시간',

        Su37: '상태',

        Su38: '공개 예정',

        Su39: '공개됨',

        Su40: '프로젝트 자료',

        Su41: '사용 가능한 잔액',

        Su42: '당장 요청',

        Su43: '모두',

        Su44: '지불 비밀번호',
    },
    option: {
        minute: '분',
        enter: ' 입력해 주세요',
        title: "옵션 계약",
        buyupreward: "총액 구매",
        buydownreward: "총 구매 및 손실",
        quantity: "오픈 포지션 금액",
        myamount: "내 오픈 포지션",
        buyup: "불리시",
        buydown: "베어 리시",
        history: "과거 결과",
        seriers: "第",
        period: "기간",
        currentoption: "이 기간의 예측 기간",
        openprice: "시가",
        currentprice: "현재 가격",
        openprice1: "시가",
        closeprice: "종가",
        opentime: "개장 시간",
        closetime: "종료 시간",
        progress: "예측 진행",
        loginFirst: "먼저 로그인하시기 바랍니다!",
        selectAmount: "베팅 횟수를 선택하세요",
        balancenotenough: "잔액 부족!",
        betsuccess: "축하합니다! 베팅이 성공했습니다!",
        noopening: "보류중인 옵션 계약 없음",
        col_createTime: "생성 된 시간",
        col_direction: "예측 방향",
        col_result: "예측 결과",
        col_optionNo: "계약 기간",
        col_betAmount: "오픈 포지션 금액",
        col_rewardAmount: "보너스 수량",
        col_fee: "오픈 포지션 수수료",
        col_winfee: "펌핑",
        win: "성공",
        lose: "실패",
        wait: "가공",
        avaliablebalance: "사용 가능한 잔액",
        login: "먼저 로그인하시기 바랍니다",
        kline: "실시간 시세",
        or1: '최신 가격',
        or2: '베팅 시간',
        or3: '베팅 금액',
        or4: '베팅 통화',
        or5: '기타 금액',
        or6: '현재 가격이 실행 가격임',
        or7: '거래 기록',
        or8: '배율',
        or9: '보너스',
        or10: '거래 기록',
        or11: '일반적인 USDT 베팅 금액 4개를 선택하세요',
    },
    otc: {
        ad: '광고 센터',
        buyin: '구입',
        sellout: '팔다',
        merchant: '상인',
        applymerchant: '공인 가맹점 신청',
        volume: '거래 수',
        paymethod: '결제 방법',
        amount: '수량',
        price_coin: '가격 / 동전',
        operate: '운영 중',
        validate: '먼저 실명 인증을 해주세요',
        sell: '팔다',
        buy: '구입',
        transaction: '거래 매매',
        buttontxt: "사업되기",
        title: "법정 화폐 거래",
        desc: "편리하고 안전하며 빠른 디지털 화폐 거래",
        title1: "동적 조정",
        desc1: "실시간 시장 가격 변동에 따라",
        title2: "무료로",
        desc2: "사용자는 그들이 얻는 것을 알 수 있습니다. 구매 및 판매 가격 외에 플랫폼 수수료가 필요하지 않습니다.",
        title3: "실시간 거래",
        desc3: "매칭을 기다리지 않고 가맹점, 지능형 매칭, 주문 거래를 지원하는 플랫폼을 소개합니다",
        title4: "플랫폼 보증",
        desc4: "플랫폼 인증 가맹점은 안전하고 보장되며 24 시간 고객 서비스가 거래를 에스코트합니다.",
        myad: {
            title: '내 광고',
            post: '광고 게재',
            alert: '[알림] : 광고의 최소 거래 금액에 수수료를 더한 금액이 남은 광고 금액보다 많을 경우 광고가 자동으로 선반에서 제거됩니다.',
            no: '광고 번호',
            type: '광고 유형',
            sell: '온라인 판매',
            buy: '온라인 구매',
            limit: '주문 제한',
            remain: '잔액',
            coin: '통화',
            created: '만든 시간',
            operate: '운영 중',
            errmsg: '광고는 제거 된 후에 만 ​​편집 할 수 있습니다.',
            update: '수정',
            shelf: '선반 위에',
            dropoff: '기성품',
            delete: '지우다',
        },
        myorder: '내 주문',
        chatline: {
            status_1: '구매자는 지불하지 않고 구매자가 지불하기를 기다리고 있습니다! ',
            status_2: '구매자가 지불하고 판매자가 출시되기를 기다리고 있습니다! ',
            status_3: '주문이 완료되었습니다! ',
            status_4: '주문이 호소되고 있습니다! ',
            status_5: '주문이 취소되었습니다! ',
            loadmore: '더로드',
            warning: '사기 예방 팁 : 최근 사기범들이 은행 송금 송금 정보와 가짜 송금 자격 증명을 반복적으로 사용하여 사기를 저지르고 있습니다. 확인하려면 수신 계정에 로그인하세요. 송금 된 자금의 안전을 보장하고 은행 카드가 동결 될 위험을 피하십시오! ',
            contenttip: '보내려면 채팅 내용을 입력하고 Enter 키를 누르세요',
            contentmsg: '메시지는 비워 둘 수 없습니다',
        },
        chat: {
            seller: '파는 사람',
            buyer: '사는 사람',
            exchangeamount: '거래 금액',
            operatetip: '작동 팁',
            operatetip_1: '지정된 기한 내에 상대방이 제공 한 계좌에 따라 결제를 완료하고이 페이지를 클릭하세요',
            finishpayment: '결제 완료',
            operatetip_1_1: '송금시 메시지의 거래 번호를 적어주세요',
            operatetip_1_2: '결제를받은 후 판매자가 웹 사이트에서 결제를 확인하고 시스템이 자동으로 구매 한 디지털 자산을 귀하의 계정으로 발행합니다. 확인 및 수신에주의하십시오.',
            note: '노트',
            notetip: '다른 채팅 소프트웨어를 사용하여 상대방과 통신하지 마시고 상대방이 보낸 파일, 이메일 첨부 파일 등을 수락하지 마십시오. 모든 통신 링크는이 페이지의 채팅 창에서 완료되어야합니다.',
            operatetip_2_1: '판매 한 디지털 자산은 보관 및 동결을 위해 플랫폼으로 넘겨졌습니다. 상대방 입금 확인 후 "를 클릭하세요".',
            operatetip_2_2: '코인의 출시를 촉구 할 이유를 믿지 마시고, 손실을 피하기 위해 입금 확인 후 디지털 자산을 출시하세요! ',
            operatetip_2_3: 'SMS 수신 후 온라인 뱅킹 또는 모바일 뱅킹에 로그인하여 사기 SMS 수신으로 인한 디지털 자산의 잘못된 유출을 방지하기 위해 자금이 계좌에 입금되었는지 확인하십시오! ',
            confirmrelease: '출시 확인',
            paydigital: '디지털 자산 결제',
            orderstatus: '주문 상태',
            orderstatus_1: '결제 완료',
            orderstatus_2: '주문 호소',
            orderstatus_3: '출시 확인',
            orderstatus_4: '거래 취소',
            orderstatus_5: '주문 호소',
            order: '주문',
            and: '대',
            transition: '거래',
            transprice: '거래 가격',
            transnum: '거래 수',
            transmoney: '거래 금액',
            tip1: '사용자가 은행 카드 번호를 추가하지 않았습니다',
            tip2: '사용자가 일시적으로 Alipay 계정을 추가하지 않았습니다',
            tip3: '사용자가 일시적으로 WeChat 계정을 추가하지 않았습니다',
            zfb: '알리 페이',
            wx: '위챗',
            qrcode: 'QR 코드',
            msg1: '결제가 완료 되었습니까?',
            msg2: '결제는 환불되지 않습니다! 주문을 취소 하시겠습니까? ',
            msg3: '[중요] : 유료 아이템은 환불되지 않습니다! 주문을 취소 하시겠습니까? ',
            msg4: '지불,받지 못한 코인',
            msg5: '코인은 지불되었지만 지불되지 않았습니다',
            tip: '신속한',
            comptype: '불만 유형',
            compremark: '불만 사항',
            willcomp: '불평하고 싶어',
            msg6: '통화를 공개 하시겠습니까? ',
            result_1: '결제 대기 중',
            result_2: '출시 대기 중',
            result_3: '완료',
            result_4: '정치',
            result_5: '취소 된',
            msg7: '펀드 비밀번호',
            msg7tip: '펀드 비밀번호를 입력 해주세요',
        },
        checkuser: {
            emaildone: '메일이 인증되었습니다',
            emailundo: '메일이 인증되지 않았습니다',
            teldone: '휴대 전화 번호가 확인되었습니다',
            telundo: '휴대 전화 번호가 확인되지 않았습니다',
            idcarddone: '신분증이 인증되었습니다',
            idcardundo: '신분증 미 인증',
            language: '언어',
            languagetext: '중국말',
            registtime: '등록 시간',
            exchangetimes: '누적 거래 횟수',
            exchangeinfo: '거래 정보',
            tablabel1: '온라인 판매',
            tablabel2: '온라인 구매',
            col_symbol: '통화',
            col_paymode: '결제 방법',
            col_num: '수량',
            col_price: '가격',
            col_created: '출시 시간',
            col_operate: '운영 중',
            operatemsg: '먼저 실명 인증을 해주세요',
            buyin: '구입',
            sellout: '팔다',
        },
        tradecenter: {
            postad: '광고 게재',
            exchange: 'GCC 거래',
            buyin: '내가 사고 싶은',
            sellout: '팔고 싶다',
        },
        tradeinfo: {
            emaildone: '메일이 인증되었습니다',
            emailundo: '메일이 인증되지 않았습니다',
            teldone: '휴대 전화 번호가 확인되었습니다',
            telundo: '휴대 전화 번호가 확인되지 않았습니다',
            idcarddone: '신분증이 인증되었습니다',
            idcardundo: '신분증 미 인증',
            exchangetimes: '업무',
            price: '가격',
            num: '수량',
            paymethod: '결제 방법',
            exchangelimitamount: '거래 한도',
            location: '위치',
            location_text: '중국',
            exchangeperiod: '거래 기간',
            minute: '분',
            amounttip: '금액을 입력하세요',
            numtip: '수량을 입력하세요',
            remarktip: '요청을 말해줘',
            remarktitle: '비고 정보',
            exchangetitle: '거래 메모',
            exchange_tip1: '거래 요청을 시작하면 디지털 통화는 보관에 잠겨 플랫폼에 의해 보호됩니다. 판매자 인 경우 거래 요청을 시작한 후 재충전하고 구매자가 지불 할 때까지 기다릴 수 있습니다. 구매자는 지불 기한 내에 지불합니다. 지불을받은 후 디지털 통화를 보관해야합니다. ',
            exchange_tip2: '거래하기 전에 "플랫폼 네트워크 서비스 약관"과 FAQ 및 거래 가이드와 같은 도움말 문서를 읽으십시오. ',
            exchange_tip3: '거짓말을 조심하십시오! 거래하기 전에 사용자가받은 평가를 확인하고 새로 생성 된 계정에 더 많은주의를 기울이십시오. ',
            exchange_tip4: '반올림 및 가격 변동은 디지털 통화의 최종 거래 금액에 영향을 미칠 수 있습니다. 입력 한 고정 금액에 따라 최종 금액이 결정되며 디지털 통화 금액은 요청이 발행되는 동시에 실시간 환율에서 계산됩니다. ',
            exchange_tip5: '보관 서비스는 온라인 거래의 구매자와 판매자를 모두 보호합니다. 분쟁이 발생하면 제공된 모든 정보를 평가하고 법적 소유자에게 보관 된 디지털 통화를 공개합니다. ',
            warning1: '소수점 2 자리까지 입력',
            warning2: '주문 금액은',
            warning3: '소수점 8 자리까지 입력',
            warning4: '주문 수량',
            confirmbuyin: '구매 확인',
            confirmsellout: '판매 확인',
            buyin: '구입',
            sellout: '팔다',
            warning5: '필요에 따라 주문을 입력하십시오',
        },
        publishad: {
            createad: '광고 거래 생성',
            msg1: '자주 거래하면 나만의 거래 광고를 만들 수 있습니다. 가끔씩 만 거래하는 경우 직접 검색하는 것이 좋습니다. ',
            msg2: '트랜잭션 광고 생성은',
            msg3: '비어 있는',
            msg4: '만든 광고를 직접 수정하려면보기 바랍니다',
            tradead: '거래 광고',
            myad: '내 광고',
            iwant: '내가 원하는',
            sellonline: '온라인 판매',
            buyonline: '온라인 구매',
            exchangecoin: '거래 통화',
            country: '국가',
            currency: '통화',
            openfixedprice: '오픈 고정 가격',
            open: '열다',
            close: '종료',
            usetip: '활성화 후 통화 가격은 시장에 따라 변동되지 않으며 가격은 변경되지 않습니다. ',
            premiseprice: '프리미엄',
            premisepricetip: '프리미엄을 설정하세요',
            fixedprice: '고정 가격',
            fixedpricetip: '거래 가격을 입력하세요',
            marketprice: '시장 기준 가격',
            marketpricetip: '프리미엄은 현재 시장 가격보다 높은 비율',
            exchangeprice: '거래 가격',
            formual: '가격 책정 공식',
            num: '수량',
            num_text1: '원하는 것을 입력하세요',
            num_text2: '수량',
            exchangeperiod: '거래 기간',
            exchangeperiod_text1: '거래 기간을 입력 해주세요',
            minute: '분',
            tip1: '구매자가 거래를 수락 할 수있는 시간, 정수를 입력하세요.',
            tip2: '[안내] 개인 센터로 이동하여 결제 수단 바인딩 / 추가',
            tip3: '최소 거래 금액을 입력하세요',
            tip4: '최대 거래 금액을 입력하십시오',
            tip5: '구매자 요구 사항, 온라인 시간 등 비고란에 특별한 요구 사항을 입력 할 수 있습니다. ',
            paymode: '결제 방법',
            minlimit: '최소 거래 금액',
            maxlimit: '최대 거래 금액',
            remark: '비고 정보',
            openautoreply: '자동 답장 켜기',
            msg5: '사용 설정 한 후 사용자가이 광고를 통해 귀하와 거래를 시작하면 시스템이 귀하가 선택한 자동 응답 언어를 상대방에게 자동으로 보냅니다. ',
            autoreply: '자동 응답',
            autoreplytip: '주문을받은 후 결제 수단, 결제 계좌 번호 등 구매자 정보에 자동으로 회신합니다. ',
            fundpwd: '펀드 비밀번호',
            fundpwdtip: '펀드 비밀번호를 입력하세요',
            submit: '제출',
            warning1: '올바른 번호를 입력하세요',
            warning2: '초과 값은 0-20',
            warning3: '최대 거래 금액을 입력하세요! ',
            warning4: '정수를 입력하세요',
            warning5: '최대 거래 금액은 최소 거래 금액보다 커야합니다! ',
            warning6: '최대 거래 금액은 총 판매 금액을 초과 할 수 없습니다.',
            warning7: '최소 거래 금액을 입력하세요! ',
            warning8: '최소 거래 금액은 100 이상이어야합니다! ',
            warning9: '최소 거래 금액은 최대 거래 금액보다 적어야합니다',
            sellout: '팔다',
            buyin: '구입',
            inputtip1: '통화를 입력하세요',
            inputtip2: '올바른 옵션을 입력하세요',
            inputtip3: '프리미엄 값은 0-20이며 0 일 수 없습니다.',
            inputtip4: '정확한 고정 가격을 입력하세요',
            inputtip5: '정확한 숫자를 입력하고 최대 거래 금액은 100 코인을 초과하지 않습니다',
            inputtip6: '올바른 거래 기한을 입력하세요',
            inputtip7: '거래 방법을 선택하세요',
            inputtip8: '펀드 비밀번호를 입력 해주세요',
            zfb: '알리 페이',
            wx: '위챗',
            unionpay: '유니온 페이',
            submit_failure: '제출 실패!',
            submit_success: '',
            submittip1: '자금의 안전을 위해 먼저 [실명 인증]을 해주세요! ',
            submittip2: '자금의 안전을 위해 먼저 [휴대 전화 바인딩]을 해주세요! ',
            submittip3: '자금의 안전을 위해 먼저 [펀드 비밀번호]를 설정 해주세요! ',
            submittip4: '적어도 하나의 결제 수단을 연결하세요',
        },
        index: {
            title: '고품질 광고 추천',
            exchangetimes: '업무',
            exchangeprice: '거래 가격',
            exchangelimit: '거래 한도',
            paymode: '결제 방법',
            buy: '구입',
            sell: '팔다',
            viewmore: '더보기',
            bot1: '안전하고 신뢰할 수있는',
            bot1_tip: '10 년 이상의 재무 리스크 관리 경험 팀은 모두 \ n 맞춤형 보안 전략 시스템 ',
            bot2: '빠르고 편리하다',
            bot2_tip: '포인트-투-포인트 사용자 무료 거래 모드는 자금 채널의 다양한 교환 방법을 지원합니다',
            bot3: '종합 통화',
            bot3_tip: '다중 자산 거래 경험의 여러 측면을 충족하기 위해 주류 디지털 자산 거래 통화 선택',
            ibuy: '내가 사고 싶은',
            isell: '팔고 싶다',
        }
    },
    activity: {
        all: "모두",
        prepare: "시작",
        ongoing: "가공",
        distributing: "배포",
        completed: "완료",
        progress: "시간표",
        totalsupply: "총 활동",
        starttime: "시작 시간",
        endtime: "종료 시간",
        viewdetail: "자세히보다",
        attend: "지금 참여하세요",
        tokendistribute: "토큰 배포 중",
        baseinfo: "기본 정보",
        status: "상태",
        activitytype: "구독 유형",
        activitytype0: "알 수 없는",
        activitytype1: "최초 온라인 (즉시 구매)",
        activitytype2: "처음 온라인 (분할)",
        activitytype3: "위치 공유",
        activitytype4: "무료 구독",
        activitytype5: "클라우드 마이닝 머신 구독",
        activitytype6: "잠금 위치 해제",
        ruledetail: "유형 설명",
        publishprice: "구독 가격",
        activitycoin: "활동 통화",
        acceptcoin: "허용 통화",
        holdcoin: "포지션 유지에 필요한 통화",
        limittimes: "개인 구매 한도",
        limitamount: "개인 구매 한도",
        unlimited: "제한 없는",
        alreadyamount: "구매 수량",
        alreadyholdamount: "활동 참여 총 위치",
        myalreadyholdamount: "내 참여 위치",
        leftamount: "잔액",
        attention: "노트",
        attentiontxt1: "1. [Position Share], [Free Subscription], [Cloud Mining Machine Subscription], [Lock Position] 유형의 활동에 참여하기 위해 제출하면 자산이 동결되고 활동 종료 후 자산이 동결 해제되거나 잠금 해제됩니다.",
        attentiontxt2: "2. [Position Share], [Free Subscription], [Cloud Mining Machine Subscription], [Lock Position] 형태의 활동에 참여한 후에는 참여 신청을 취소 할 수 없습니다.",
        attentiontxt3: "3. 프로젝트 파티 및 기타 불가항력 요인으로 인해 이벤트가 취소 된 경우 원래 경로는 동결 된 자산으로 반환됩니다.",
        attentiontxt4: "* 본 행사의 최종 해석은 BIPPAX 공식 웹 사이트 (www.bippaxcoins.com)에 있습니다.",
        inputamount: "교환 금액 입력",
        inputholdamount: "잠금 위치 입력",
        mybalance: "내 가용 잔액",
        holdtips: "[보유 지분] 유형 활동에 참여하려면 활동이 끝날 때까지 위치를 고정해야합니다.",
        pleaseinputamount: "환전 금액을 입력하세요",
        pleaseinputholdamount: "잠긴 위치를 입력하십시오",
        commitfailed: "참가 제출 실패!",
        minlimitamountfailed: "교환 금액은 최소 교환 금액보다 적을 수 없습니다!",
        maxlimitamountfailed: "교환 금액은 최대 구매 한도를 초과 할 수 없습니다!",
        limittimesfailed: "참가 횟수가 개인 구매 한도를 초과했습니다!",
        balancenotenough: "잔액 불충분!",
        headertitledesc: "투자자, 프로젝트 당사자, 거래소 및 기타 당사자가 함께 승리 할 수있는 개방형 실험실",
        currentdivided: "현재 내 위치는 나눌 수있다",
        leveloneCount: "1 단계 친구 필요",
        submit: "제출",
        tipsmobile: "참여하려면 컴퓨터 페이지 (www.bippaxcoins.com)를 입력하세요.",
        tipsmobile1: "컴퓨터 측에서 (www.bippaxcoins.com)을 열고 참여할 혁신 실험 영역에 들어 가세요",
        intvalue: "정수를 입력하십시오",
        inputminingamount: "구매 한 광부의 수를 입력하십시오",
        moreactivity: "기타 활동",
        releaseType: "릴리스 유형",
        releaseType0: "동량 방출",
        releaseType1: "비례 방출",
        lock: "기간 출시",
        releaseDetail: "출시 정보",
        lockday: "일",
        lockweek: "주",
        lockmonth: "달",
        lockyear: "년",
        releasePercent: "방출 비율",
        lockFee: "잠금 임계 값",
        releaseTimes: "복수 해제",
        times: "타임스"
    },
    invite: {
        myinvitelink: "내 초대 링크",
        copy: "부",
        copyed: "복사 됨",
        mylevelone: "내 일등 친구",
        myleveltwo: "2 차 친구",
        mycommission: "수수료 수입 (USDT 상당)",
        extrareward: "추가 보너스",
        partnerlevel: "파트너십 수준",
        ruledetail: "규칙 세부 정보",
        ruleprofile1: "BIPPAX (www.bippaxcoins.com) [Promotion Partner]는 전체 네트워크입니다.",
        ruleprofile2: "최고의 리베이트 비율",
        ruleprofile3: "가장 긴 리베이트 기간 (최대 평생 리베이트)",
        ruleprofile4: "프로모션 활동은 이에 상응하는 노력을 기울인 프로모터가 진정한 의미에서 플랫폼 '파트너' 가 될 수 있고 BIPPAX 거래 플랫폼과 함께 성장하는 보너스를 누릴 수 있도록합니다! 구체적인 규칙은 다음과 같습니다.",
        ruletext1: "1. BIPPAX (www.bippaxcoins.com)는 디지털 자산의 개념을 홍보하고 사용자 규모를 확대하기 위해 오랫동안 효과적인 [프로모션 파트너] 프로그램을 시작했습니다.",
        ruletext2: "2 단계. 친구를 초대하는 단계는 두 가지입니다. A가 B를 초대하면 B는 A의 1 단계 친구입니다. B가 C를 초대하면 C는 B의 1 단계 친구에 속하고 A의 2 단계 친구에도 속합니다.",
        ruletext3: "3. 승격 된 친구를 등록 할 때 초대자가 제공 한 링크를 사용하거나 초대 자의 초대 코드를 수동으로 입력해야 초대 자의 1 단계 친구가됩니다.",
        ruletext4: "4. 초대받은 사람이 초대 자 초대 코드로 등록하고 실명 인증을 완료하면 리베이트 인센티브 만 적용됩니다.",
        ruletext5: "5. 커미션 리베이트 시간은 초대받은 사람이 실명 인증을 완료 한 날로부터 N 개월입니다.받는 커미션 리베이트 비율은 레벨에 따라 다릅니다.",
        ruletext6: "6. 프로모션 리베이트 자산은 하위 레벨 친구 통화의 거래 수수료입니다. 리베이트 통화는 USDT, BTC, ETH의 세 가지 기본 시장 통화입니다.",
        ruletext7: "7. 프로모션 리베이트 비율 및 리베이트 기간은 프로모션의 1 단계 친구 수와 양의 상관 관계가 있습니다. 프로모터 수가 많을수록 리베이트 비율이 높아집니다. 구체적인 프로모션 리베이트 비율은 다음과 같습니다.",
        ruletext8: "8. 리베이트 순위에서 TOP10 또는 TOP100의 프로모션은 때때로 BIPPAX (www.bippaxcoins.com)에서 공식적으로 발행 한 추가 보상을받습니다.",
        ruletext9: "9. [프로모션 파트너] 활동과 다른 활동이 상충 될 경우 임시 변경 여부는 협상 후 결정됩니다. 파트너가 이해해 주셨으면합니다.",
        ruletext10: "Ten, L4 (지사), L5 (Prefect), L6 (Jidu Shi) 레벨 파트너는 총 연간 커미션 리베이트의 5 %, 10 % 및 15 %를 누릴 수 있습니다.",
        ruletext11: "11. 본 행사의 최종 해석 권은 BIPPAX (www.bippaxcoins.com)에 있습니다.",
        ruleexampletitle: "예 :",
        ruleexamplecontent1: "사용자 Xiaoyan이 100 명의 1 급 친구를 초대하고 TA의 1 급 친구가 5 명의 2 급 친구를 초대했다면 Xiaoyan은 1 급 친구 100 명과 2 급 친구 500 명을 갖게됩니다. 3,000 위안의 거래, Xiaoyan의 월 소득은 대략 (100 * 3000 * 0.001 * 30 % + 500 * 3000 * 0.001 * 10 %) * 30 = 7200 / 월입니다. ",
        ruleexamplecontent2: "사용자 Xiaoyan이 1 급 친구 1,000 명을 초대하고 TA의 1 급 친구가 2 급 친구 5 명을 초대했다면 Xiaoyan은 1 급 친구 1,000 명과 2 급 친구 5,000 명을 보유하고 있습니다. 3,000 위안 거래시 Xiaoyan의 월 수입은 대략 (1000 * 3000 * 0.001 * 50 % + 5000 * 3000 * 0.001 * 20 %) * 30 = 135000 / 월입니다. ",
        lastupdate: "최종 업데이트 날짜",
        laststastic: "통계 마감일",
        level: "수평",
        lv1: "리젱",
        lv2: "카운티 주문",
        lv3: "지사",
        lv4: "총재",
        lv5: "지사",
        lv6: "젠 두시",
        levelonecount: "1 단계 친구 수",
        levelonecommission: "1 단계 친구 리베이트 비율 / 리베이트 시간",
        leveltwocommission: "2 단계 친구 리베이트 비율 / 리베이트 시간",
        partnerdivide: "파트너 배당금",
        month: "달",
        alllife: "평생 리베이트",
        totalcommissionrank: "총 프로모션 리베이트",
        rank: "계급",
        userid: "사용자 ID",
        rankday: "(日 榜)",
        rankweek: "(周 榜)",
        rankmonth: "(월 목록)",
        rankall: "(전체 목록)",
        promotioncount: "프로모션 수",
        commissionusdt: "환급 (USDT 상당)",
        ranktip1: "초대 수는 1 급 친구의 수이며이 목록은 총 리베이트 금액의 순위입니다.",
        ranktip2: "초대 수는 1 단계 친구의 수이며이 목록은 1 단계 초대 번호 순위입니다.",
        thanks: "BIPPAX (www.bippaxcoins.com)와 함께 성장 해주셔서 감사합니다!",
        headertip: "위의 수수료 데이터는 실시간으로 업데이트되지 않습니다. 시스템은 24 시간마다 카운트하고 업데이트합니다.",
        ptools: "프로모션 도구 상자",
        pt_title: "디지털 화폐 기프트 카드",
        pt_desc: "사용 후 자동으로 하위 친구가되어 친구, 친척, 고객 및 파트너를 보내 게됩니다. 프로모션 파트너가 더 잘 홍보 할 수 있도록 도와주세요.",
        pt_more: "더 많은 도구, 계속 지켜봐주십시오.",
        pt_tips: "좋은 아이디어가 있으시면 promotion@BIPPAX.com으로 이메일을 보내 주시면 입양 후 보상을드립니다!",
        pt_card_amount: "카드 금액",
        pt_card_deadline: "유효 기간",
        pt_card_noend: "무기한",
        pt_card_btn: "프로모션 파트너는 30 장의 무료 티켓 (약 2000 위안)을받습니다.",
        pt_card_btn_login: "로그인 후 무료 티켓 30 장 받기",
        pt_card_rule: "규칙 세부 정보",
        pt_card_summary: "디지털 화폐 기프트 카드는 프로모션 파트너가 오프라인 친구를 더 잘 초대 할 수 있도록 개발 된 프로모션 도구 중 하나입니다. 대상 사용자가 기프트 카드를 사용하면 자동으로 프로모터의 오프라인 친구가됩니다.",
        pt_card_rule1: "1. 무료 기프트 카드는 사용자 당 30 개로 제한됩니다. 더 많은 기프트 카드를 발행해야하는 경우 사용자 정의 비용을 지불해야하며 카드 얼굴 금액, 로고, 설명 텍스트 등을 사용자 정의 할 수 있습니다.'로 이메일을 보내주십시오.'",
        pt_card_rule2: "2. 무료 기프트 카드는 사용자 당 1 개로 제한됩니다. BIPPAX (www.bippaxcoins.com)에서 공식적으로 발행 한 무료 기프트 카드는 사용자마다 다른 사용 코드를 무료로 받더라도 사용자 당 1 개로 제한됩니다. 기프트 카드는 한 장으로 만 교환 할 수 있습니다. 맞춤 제작 된 기프트 카드에는이 제한이 적용되지 않습니다. ",
        pt_card_rule3: "3. 사용자가 기프트 카드를 사용하기 전에 '초대' 가없는 경우 (즉, 계정 등록시 초대 코드가 입력되지 않은 경우) 카드 발급 사의 1 단계 친구와 자동으로 연결됩니다. A가 계정을 등록 할 때 초대 코드를 입력하지 않으면이 당시 A는 어느 누구의 1 급 또는 2 급 친구에 속하지 않지만 A가 B가 발행 한 기프트 카드를 교환하면 A는 자동으로 B의 1 급 친구가됩니다. ",
        pt_card_rule4: "4. 고객이 스 와이프되는 것을 방지하기 위해 기프트 카드의 장부가는 실시간으로 사용되지 않습니다. 수령 후 실명 인증을 완료 할 수 있습니다.",
        pt_card_rule5: "다섯째, 무료 기프트 카드 수령시 실명 인증을 완료해야하며, 교환시 실명 인증을 완료하지 않고 수령 할 수 있습니다. 이는 프로모터들이 낮은 레벨의 친구를 더 빨리 얻을 수 있도록하기 위함입니다.",
        pt_card_rule6: "VI. 무료 기프트 카드의 최종 해석 권한은 www.bippaxcoins.com에 있습니다.",
        pt_card_day: "일",
        pt_card_title_tips: "2 천 위안의 홍보 지원금 받기",
        pt_card_receivew_success: "축하합니다! 파트너 프로모션 상품권을 성공적으로 받았습니다. [개인 센터]-> [카드 & 쿠폰 센터]에서 확인하세요!",
        usepromotion: "홍보 자료 사용",
        saveimage: "사진을 저장하다",
        imagetips: "사진을 정상적으로 다운로드 할 수없는 경우 스크린 샷 도구를 사용하여 저장하십시오!",
        pt_invite_title: "홍보 이미지 등록 초대",
        pt_invite_desc: "독점 QR 코드, QR 코드 등록을 통해 자동으로 하위 친구가되어 다양한 그룹이나 포럼에 전달하기에 적합합니다.",
        colum_text0: "계급",
        colum_text1: "회원",
        colum_text2: "프로모션 수",
        colum_text3: "환급 (USDT 상당)",
        colum_text4: "추가 보너스",
        context_title: "프로모션 파트너를위한 독점 사용 코드",
        context_title1: "자세히 알아 보려면 스캔",
        context_title2: "내 초대 코드",
        context_title3: "초대 이미지"
    },
    uc: {
        verify: "확인 됨",
        login: {
            noaccount: '계정이 없습니까? ',
            register: '등기',
            login: '로그인',
            welcomelogin: '로그인하세요',
            usertip: '전화 번호 또는 이메일을 입력하세요',
            pwdtip: '비밀번호를 입력하세요',
            validatecodeload: '인증 코드로드 중',
            validatemsg: '먼저 확인을 완료하십시오',
            forget: '비밀번호 분실?',
            loginvalidate: '사용자 이름을 입력하십시오',
            pwdvalidate1: '비밀번호를 입력하세요',
            pwdvalidate2: '비밀번호 길이는 6 자리 미만일 수 없습니다.',
            success: '성공적 로그인',
            goregister: "지금 등록하세요",
            getlostpwd: "비밀번호 분실"
        },
        forget: {
            title: "비밀번호 검색",
            hasaccount: '이미 계정이 있습니까? 로그인을 클릭하십시오 ',
            login: '로그인',
            sendcode: '인증 코드 보내기',
            newpwd: '새 비밀번호를 입력하세요',
            confirmpwd: '비밀번호를 다시 확인해주세요',
            save: '제출',
            pwdvalidate1: '확인 비밀번호를 입력하세요',
            pwdvalidate2: '두 암호 항목이 일치하지 않습니다!',
            resettelpwd: '전화 비밀번호 재설정',
            resetemailpwd: '이메일 비밀번호 재설정',
            newpwdtip: '새 비밀번호를 입력하세요',
            pwdvalidate3: '비밀번호 길이는 6 자리 미만일 수 없습니다.',
            telno: '전화 번호',
            mtelno: '휴대폰 인증',
            memail: '메일박스 인증',
            smscode: '인증 코드를 입력하세요',
            teltip: '전화 번호를 입력하세요',
            smscodetip: 'SMS 인증 코드를 입력하세요',
            email: '사서함',
            emailcode: '이메일 인증 코드',
            emailtip: '이메일을 입력 해주세요',
            emailcodetip: '이메일 인증 코드를 입력 해주세요',
            resetpwdsuccess: '비밀번호 재설정 성공',
            smswarn: 'SMS 확인에주의 해주세요',
        },
        finance: {
            center: '금융 센터',
            personalassets: '통화 계정',
            swapassets: '영구 계정',
            billdetail: '자산 흐름',
            tradetail: '거래 마이닝',
            paydividends: '통화 배당금 보유',
            invitingmining: '채굴 보상 초대',
            charge: '충전',
            pickup: '철수',
            fi1: ' 작은 자산 숨기기',
            money: {
                M1: '받은 수량',
                M2: '전출 수량',
                M3: '환율',
                cointype: '통화 명',
                balance: '사용 가능한 자산',
                frozen: '자산 고정',
                operate: '운영 중',
                charge: '충전',
                pickup: '철수',
                onkeytrans: "돌릴 하나의 열쇠",
                getaddress: '주소 받기',
                resetsuccess: '성공하라',
                match: '쌍',
                matchtip1: '페어링 가능한 GCX 수',
                matchtip2: '쌍의 수를 입력하세요',
                matcherr1: '유효한 수량을 입력하세요!',
                matcherr2: '최대 쌍수 초과!',
                matchsuccess: '페어링 성공!',
                needreleased: "출시 될 자산",
                totalassets: "동등한 총 자산 :"
            },
            swap: {
                totalassets: "계정 자본 전환 :",
                swap: "영구 계정",
                swaptype: '계약 계정',
                swapassets: "계정 자산",
                avabalance: "사용 가능한 마진",
                usebalance: "사용 된 마진",
                frozenbalance: "여백 고정",
                profitandloss: "미실현 이익 및 손실",
                transfor: "자금 이체",
                inputtransferamount: "이체 금액",
                all: "모두 전송",
                currencyaccount: "통화 계정",
                swapaccount: "영구 계약 계정",
                clickchange: "스 와이프 방향을 전환하려면 클릭하세요.",
                avaamount: "양도 가능 금액",
                pleaseselectwallet: "먼저 입출금 계좌를 선택하세요",
                pleaseinputamount: "이체 금액을 입력하세요",
                oktransfer: "이체 확인"
            },
            record: {
                Please: '검색 기간을 선택하십시오',
                start_end: '시작 및 종료 시간',
                to: '에',
                operatetype: '작업 유형',
                search: '검색',
                charge: '충전',
                pickup: '빼다',
                transaccount: '이전',
                exchange: '코인 화폐 거래',
                otcbuy: '피아트 화폐 구매',
                otcsell: '피아트 화폐 판매',
                activityaward: '활동 상',
                promotionaward: '프로모션 보상',
                dividend: '피제수',
                vote: '투표',
                handrecharge: '수동 충전',
                match: '쌍',
                activitybuy: "활동 교환",
                ctcbuy: "CTC 구매",
                ctcsell: "CTC 판매",
                redout: "빨간 봉투",
                redin: "칼라 레드 봉투",
                chargetime: '거래 시간',
                type: '유형',
                fee: '수수료',
                shouldfee: '지불 처리 수수료',
                revenue: '수지 유형',
                re1: '입금',
                re2: '출금',
                discountfee: '수수료 공제',
                realfee: '결제 수수료',
                symbol: '통화',
                num: '수량',
                status: '상태',
                finish: '완료',
                activitybuy: "활동 교환",
                ctcbuy: "C2C 구매",
                ctcsell: "C2C 판매",
                quickExchange: "플래시 사용",
                currentRate: "현재 환율",
                from: "에서",
                inputexchangeamount: "플래시 양 입력",
                inputexchangepasswd: "거래 비밀번호 입력",
                chooseTransCoinUnit: "변환 통화 선택",
                inputTransAmount: "전환 수 입력",
                predictAmount: "예상 교환 가능 수량",
                qamount: "플래시 양",
                qrate: "환율",
                qexamount: "교환 수량",
                withdrawcodein: "출금 코드 및 입금",
                withdrawcodeout: "출금 코드 철회",
                contractfee: "영구 계약 처리 수수료",
                contractprofit: "영구 계약 이익",
                contractloss: "영구 계약 손실",
                optionfail: "예측 계약 실패",
                optionfee: "예측 계약 수수료",
                optionreward: "예측 계약 보너스",
                other: "다른"
            },
            paydividende: {
                money_holding: '돈 보유 배당금이 누적 반환되었습니다 (ETH):',
                money_hold: '반환 할 총 배당금 (ETH):',
                paydividends: '통화 배당금 (ETH) 보유',
                account_date: '도착 시간',
                datehodld: '통화 보유 일',
                start_end: '시작 및 종료 시간',
                to: '에',
                operatetype: '작업 유형',
                search: '검색',
                charge: '충전',
                pickup: '빼다',
                transaccount: '이전',
                exchange: '코인 화폐 거래',
                otcbuy: '피아트 화폐 구매',
                otcsell: '피아트 화폐 판매',
                activityaward: '활동 상',
                promotionaward: '프로모션 보상',
                dividend: '피제수',
                vote: '투표',
                handrecharge: '수동 충전',
                match: '쌍',
                chargetime: '거래 시간',
                type: '유형',
                fee: '수수료',
                symbol: '통화',
                num: '수량',
                status: '상태',
                finish: '완료',
            },
            trade: {
                start_end: '시작 및 종료 시간',
                account_date: '도착 시간',
                to: '에',
                operatetype: '작업 유형',
                search: '검색',
                charge: '충전',
                pickup: '빼다',
                transaccount: '이전',
                exchange: '코인 화폐 거래',
                otcbuy: '피아트 화폐 구매',
                otcsell: '피아트 화폐 판매',
                activityaward: '활동 상',
                promotionaward: '프로모션 보상',
                dividend: '피제수',
                vote: '투표',
                handrecharge: '수동 충전',
                match: '쌍',
                chargetime: '주문 생성 시간',
                type: '유형',
                fee: '채굴 료 환불 (BHB)',
                num: '수량',
                status: '상태',
                finish: '완료',
                transactionTime: '거래 시간',
                symbol: '거래 쌍',
                direction: '무역 방향',
                price: '가격',
                entrustment: '수탁 금액',
                havedeal: '거래 완료',
                poundageAmount: '수수료',
                exchangeOrderId: "주문 아이디",
                mineAmount: "채굴 할 코인 수 (BHB)",
                buy: "구입",
                sell: "팔다",
                limit: "한정 가격",
                market: "시장 가격",
                clear: "빈 상태",
                turnover: "회전율"
            },

            recharge: {
                recharge: '충전',
                symbol: '통화',
                address: '입금 주소',
                copy: '부',
                qrcode: 'QR 코드',
                qrcodeaddress: '충전 주소 QR 코드',
                msg1: '위 주소로 비 통화 자산을 충전하지 마십시오. 그렇지 않으면 자산이 회수되지 않습니다. ',
                msg2: '위 주소로 재충전 후 전체 블록 체인 네트워크 노드를 확인해야합니다. 일반적으로 블록 체인 메인 네트워크는 3 번의 네트워크 확인 후 도착합니다. ',
                msg3: '최소 충전량 :',
                msgtop: '이 주소는 충전 전용입니다',
                msg3_1: ", 최소 금액 미만의 충전은 게시되지 않습니다.",
                msg4: '충전 주소는 자주 변경되지 않으니 재충전하실 수 있습니다. 변경 사항이있을 경우 홈페이지 공지 사항이나 이메일로 알려 드리겠습니다. ',
                msg5: '정보가 변조되거나 유출되지 않도록 컴퓨터와 브라우저가 안전한지 확인하십시오. ',
                record: '충전 기록',
                copysuccess: '복사 성공! ',
                copyerr: '복사 실패! 수동으로 복사하십시오 ',
                time: '도착 시간',
                amount: '충전 수량',
                gettingaddress: "충전 주소를 가져 오는 중입니다. 잠시만 기다려주십시오 ...",
                getaddress: "충전 주소 받기",
                memotips: "충전 할 때 필요에 따라이 메모를 입력하십시오. 그렇지 않으면 자산을 잃게됩니다.",
                withdrawrecharge: "출금 코드 재충전",
                coderechargetip: "출금 코드를 입력하세요",
                rechargesuccess: "축하합니다! 출금 코드가 성공적으로 재충전되었습니다!",
                rechargeconfirm: "충전 확인",
                status: "상태"
            },
            withdraw: {
                pickup: '철수',
                addressmanager: '출금 주소 관리',
                withdrawbycode: '출금 코드 철회',
                withdrawcode: '출금 코드',
                symbol: '통화',
                address: '출금 주소',
                num: '출금 금액',
                avabalance: '사용 가능한 잔액',
                msg1: '출금 금액이보다 적다',
                msg2: '계정이 자동으로 수신되면 수동 검토가 필요합니다.',
                increase: '할당량 늘리기',
                tip1: '최대 입력',
                tip11: '십진수, 최소값은',
                tip2: '최대 값은',
                numtip1: '출금 횟수 입력',
                fee: '수수료',
                range: '범위',
                arriamount: '도착 수량',
                msg3: '최소 출금 금액은',
                msg4: '통화',
                msg5: '자금의 안전 확보를 위해 계정 보안 정책 변경, 비밀번호 변경, 새 주소로 출금시 수동으로 출금을 검토하겠습니다. 담당자가 전화 나 이메일로 연락을 드릴 때까지 기다려 주시기 바랍니다.',
                msg6: '정보가 변조되거나 유출되지 않도록 컴퓨터와 브라우저가 안전한지 확인하십시오. ',
                record: '출금 기록',
                symboltip: '통화를 선택하세요',
                addresstip: '주소를 입력 해주세요',
                numtip2: '정확한 출금 횟수를 입력하세요. 최소 금액은 다음과 같습니다.',
                numtip3: '인출 횟수는 수수료보다 적 으면 안됩니다',
                amounttip: '출금 횟수를 입력하세요',
                feetip1: '최소 취급 수수료는',
                feetip2: '최대 값은',
                time: '출금 시간',
                status: '상태',
                status_1: '검토 중',
                status_2: '전송 중',
                status_3: '실패',
                status_4: '성공',
                St5: '예상 가격 강함',
                St6: '총 자산 = 지갑 잔액 + 미실현',
                St7: '손익 미실현 = 모든 보유 계약은 최신 가격으로 계산된 미실현 손익',
                St8: '지갑 잔액 = 전입 - 전출 - 이미 손익 실현',
                St9: '거부됨',
                remark: '비고',
                add: '추가',
                addresslist: '주소 목록',
                safevalidate: '안전 검증',
                telno: '휴대 전화 번호',
                smscode: '모바일 인증 코드',
                second: '둘째',
                clickget: '얻으려면 클릭',
                email: '사서함',
                emailcode: '이메일 인증 코드',
                save: '저장',
                delete: '지우다',
                telerr: '휴대 전화 번호가 잘못되었습니다',
                emailerr: '이메일이 잘못되었습니다',
                codeerr: '잘못된 인증 코드',
                remarktip: '메모를 입력하세요',
                savemsg1: '저장 실패!',
                savemsg2: '성공적으로 저장되었다!',
                operate: '운영 중',
                fundpwdtip: '펀드 비밀번호를 입력 해주세요',
                click: '딸깍 하는 소리',
                filtrate: '필터링 가능',
                txid: "TxId",
                generateCode: "출금 코드 생성",
                withdrawcodelist: "출금 코드 목록",
                withdrawcodestatus: "상태",
                submit: "제출",
                generatecodesuccess: "출금 코드가 성공적으로 생성되었습니다.",
                wi1: '네트워크 ',
                wi2: '보안 인증',
                wi3: '입금 수량 ',
                wi4: '입금 주소',
                wi5: ' 출금 네트워크',
                wi6: '총 출금 금액',
                wi7: '네트워크 수수료 ',
                wi8: '출금 주소를 정확하게 입력하고 선택한 출금 네트워크가 주소와 일치하는지 확인해주세요.',
                wi9: '출금 주문은 생성 후 취소할 수 없습니다. ',
                wi10: '계속 ',
                wi11: '자금 비밀번호',
                wi12: '휴대폰 인증 코드',
                wi13: '인증 보내기',
                wi14: ' 이메일 인증 코드',
                wi15: '인증 보내기',
                wi16: '제출',
            }
        },
        member: {
            usercenter: "개인 센터",
            securitycenter: '보안 센터',
            securitysetting: '보안 설정',
            accountsetting: '결제 방법',
            account: "계정 관리",
            assets: "자금 관리",
            exchange: "거래 관리",
            curdelegate: "현재 주문",
            hisdelegate: "역사위원회",
            otc: "OTC 관리"
        },
        order: {
            ordercenter: '주문 센터',
            myorder: '내 주문',
            myad: '내 광고',
        },
        regist: {
            Res1: '사용자 이름은 대소문자와 숫자로 구성되며 문자를 포함해야 합니다',
            hasaccount: '이미 계정이 있습니까? 로그인을 클릭하십시오 ',
            login: '로그인',
            username: '사용자 이름',
            country: '국가',
            smscode: 'SMS 인증 코드',
            sendcode: '인증 코드 보내기',
            resendcode: '재전송 (',
            pwd: '로그인 비밀번호',
            repwd: '비밀번호 확인',
            confrimpwd: '비밀번호 확인',
            agreement: '나는 읽고 동의합니다',
            userprotocol: '사용자 동의',
            regist: '등기',
            teltip: '전화 번호를 입력하세요',
            telerr: '휴대 전화 번호 형식이 잘못되었습니다. 다시 입력하세요.',
            emailtip: '이메일을 입력 해주세요',
            emailerr: '이메일 형식이 올바르지 않습니다. 다시 입력하십시오.',
            confirmpwdtip: '확인 비밀번호를 입력하세요',
            confirmpwderr: '두 암호 항목이 일치하지 않습니다!',
            telregist: '휴대 전화 등록',
            emailregist: '이메일 등록',
            usernametip: '사용자 이름을 입력하십시오',
            usernamemsg: '사용자 이름 길이는 3 자리 이상 15 자리를 초과 할 수 없습니다.',
            countrytip: '국가를 선택하세요',
            smscodetip: 'SMS 인증 코드를 입력하세요',
            pwdtip: '비밀번호를 입력하세요',
            pwdmsg: '비밀번호 길이는 6 자리 미만일 수 없습니다.',
            telno: '휴대 전화 번호',
            email: '이메일 주소',
            agreementtip: '동의하려면 클릭하세요',
            modaltitle: '확인 부탁합니다',
            promotion: '초대 코드',
            china: '중국',
            singapore: '싱가포르',
            korea: '대한민국',
            japan: '일본',
            thailand: '태국',
            russia: '러시아',
            uk: '영국',
            vietnam: '베트남',
            india: '인도',
            italy: '이탈리아',
            hk: '홍콩',
            malaysia: '말레이시아',
            taiwan: '대만 지방',
            turkey: '터키',
            germany: '독일',
            france: '프랑스',
            spain: '스페인',
            us: 'American',
        },
        safe: {
            beneficiaryTitle: '수익자 정보',
            beneficiaryEmpty: '수익자 정보가 아직 설정되지 않았습니다',
            beneficiaryName: '수익자 이름',
            beneficiaryIdNumber: '수익자 신분증 번호',
            beneficiaryMobilePhone: '수익자 휴대전화 번호',
            beneficiaryNamePlaceholder: '수익자 이름을 입력해 주세요',
            beneficiaryIdPlaceholder: '수익자 신분증 번호를 입력해 주세요',
            beneficiaryMobilePlaceholder: '수익자 휴대전화 번호를 입력해 주세요',
            beneficiaryTip: '수익자의 이름, 신분증 번호 및 휴대전화 번호를 등록하고 수정하는 데 사용됩니다.',
            beneficiaryNameRequired: '수익자 이름을 입력해 주세요',
            beneficiaryNameInvalid: '수익자 이름은 2자 이상 30자 이하로 입력해 주세요',
            beneficiaryIdRequired: '수익자 신분증 번호를 입력해 주세요',
            beneficiaryIdInvalid: '수익자 신분증 번호 형식이 올바르지 않습니다',
            beneficiaryMobileRequired: '수익자 휴대전화 번호를 입력해 주세요',
            beneficiaryMobileInvalid: '수익자 휴대전화 번호 형식이 올바르지 않습니다',
            Ad1: '사회보험카드, 운전면허증 또는 여권을 업로드하십시오',
            Ad2: '제출하기 전에 파일 중 하나를 업로드합니다.',
            Ad3: '전체 이름',
            Ad4: '연락 주소',
            Ad5: '생방송',
            Ad6: '마이 라이브',
            Ad7: '추가 실패, 최대 3개만 추가',
            size: '사진 업로드 크기는 5M을 초과하면 안 됩니다',
            safelevel_low: '보안 수준 : 낮음',
            safelevel_high: '보안 수준 : 높음',
            safelevel_medium: '보안 수준 : 중간',
            nickname: '별명',
            bind: '제본',
            binded: '경계',
            binding: '검토 중',
            binderr: '실패',
            bindretry: '다시 해 보다',
            verifypass: "확인 됨",
            verified: '인증 됨',
            notverified: "인증되지 않음",
            verifiedtip: '계정 보안을 위해 거래 전 실명 인증을 완료 해주세요! ',
            realname: '실명',
            idcard: '식별 번호',
            upload: '업로드하려면 클릭',
            upload_positive: '신분증 앞면 사진',
            upload_negative: '신분증 뒷면 사진',
            upload_hand: '손잡이 신분증 및 개인 서명 사진',
            save: '저장',
            reset: '초기화',
            email: '사서함',
            bindemail: '바인딩 사서함',
            loginpwd: '로그인 비밀번호',
            emailcode: '이메일 인증 코드',
            clickget: '얻으려면 클릭',
            second: '둘째',
            phone: '전화',
            bindphone: '바인드 폰',
            phonecode: '모바일 인증 코드',
            logintip: '플랫폼에 로그인 할 때 사용',
            edit: '수정',
            oldpwd: '원래 로그인 비밀번호',
            newpwd: '새 로그인 비밀번호',
            confirmnewpwd: '새 비밀번호 확인',
            fundpwd: '펀드 비밀번호',
            fundtip: '계좌 자금 변경시 먼저 자금 비밀번호 확인 필요',
            set: '설정',
            confirmpwd: '비밀번호 확인',
            oldfundpwd: '원 펀드 비밀번호',
            newfundpwd: '새 펀드 비밀번호',
            newpwdmsg1: '새 로그인 비밀번호를 6 개 이상 입력하세요',
            newpwdmsg2: '새 로그인 비밀번호가 일치하지 않습니다',
            pwdmsg1: '비밀번호는 6 자리 이상으로 입력 해주세요',
            pwdmsg2: '비밀번호가 일치하지 않습니다',
            emailtip: '사서함 번호를 입력하세요',
            codetip: '인증 코드를 입력하세요',
            telnotip: '전화 번호를 입력하세요',
            oldpwdtip: '원래 비밀번호를 입력하세요',
            realnametip: '실명을 입력 해주세요',
            idcardtip: 'ID 번호를 입력 해주세요',
            bindphonetip: '휴대 전화를 먼저 묶어주세요!',
            resetfundpwd: '펀드 비밀번호 재설정',
            upload_positivetip: '신분증 앞면 사진 업로드 해주세요',
            upload_negativetip: '신분증 뒷면 사진 업로드 해주세요',
            upload_handtip: '휴대용 증명 사진을 업로드 해주세요',
            save_success: '성공적으로 저장되었다!',
            save_failure: '저장 실패!',
            idcard_verifymsg1: "1. JPG 및 PNG 형식을 지원하며 파일은 8M 미만입니다. 인증서의 정보가 명확하게 표시되고 수정 또는 방해가 허용되지 않으며 인증서 번호와 이름이 명확하게 보여야합니다.",
            idcard_verifymsg2: "2. 사진에는 캡이 없어야하며 화장은 권장하지 않으며 신분증을 들고있는 사람의 얼굴 특징이 선명하게 보이고 팔이 완전히 노출되어 있어야합니다.",
            idcard_verifymsg3: "3. 인증서와 자필 사본 (이름 + 신청일)을 동시에 보유해야합니다.'이 사이트에서 수행하는 모든 작업은 본인의 작업이며 관련 위험을 알고 있으며이 계정의 모든 법적 결과를 기꺼이 감수 할 것입니다.'"
        },
        account: {
            pagetitle: '실명 계좌 구속',
            pagetip: '결제 방법을 설정해주세요. 실명 계좌를 사용 해주세요',
            backcardno: '은행 카드 계좌 번호',
            backcardtip: '개인 은행 카드 정보는 구속력이 없습니다',
            modify: '수정',
            bind: '제본',
            name: '이름',
            bankaccount: '계좌 은행',
            bankbranch: '계좌 개설 점',
            bankno: '은행 카드 번호',
            confirmbankno: '카드 번호 확인',
            fundpwd: '펀드 비밀번호',
            save: '저장',
            zfbaccount: '알리 페이 계정',
            zfbaccounttip: '개인 Alipay 계정은 바인딩되지 않았습니다',
            wxaccount: 'WeChat 계정',
            wxaccounttip: '개인 WeChat 계정이 바인딩되지 않았습니다',
            banknomsg1: '정확한 은행 카드 번호를 입력하십시오',
            banknomsg2: '입력 한 두 개의 은행 카드 번호가 일치하지 않습니다!',
            verifiedmsg: '먼저 실명 인증을 해주세요',
            bankaccountmsg: '계좌 은행을 선택하십시오',
            bankbranchmsg: '계좌 개설 지점을 입력 해주세요',
            banknomsg: '정확한 은행 카드 번호를 입력하십시오',
            fundpwdmsg1: '올바른 펀드 비밀번호를 입력하세요',
            fundpwdmsg2: '비밀번호는 6 자 이상이어야합니다.',
            zfbaccountmsg: '알리 페이 계정을 입력하세요',
            wxaccountmsg: 'WeChat 계정을 입력하십시오',
            save_success: '성공적으로 저장되었다!',
            save_failure: '저장 실패!',
            imgtip: '결제 코드를 업로드하세요',
        },
        otcorder: {
            unpaid: '미지급',
            paided: '이미 지불',
            finished: '완료',
            canceled: '취소 된',
            appealing: '정치',
            searchtip: '검색을 시작하려면 주문 번호를 입력하세요',
            orderno: '주문 번호',
            created: '만든 시간',
            symbol: '거래 통화',
            type: '거래 유형',
            type_sell: '팔다',
            type_buy: '구입',
            tradename: '거래 파트너',
            amount: '수량',
            money: '양',
            fee: '수수료',
        },
        identity: {
            certified: "확인 됨",
            placeholder: "취소 이유를 입력 해주세요",
            apply: '사업 신청',
            become: 'BIPPAX 인증 가맹점이되어 더 많은 거래 특권을 누리세요',
            zhusnhu: "기업인은 거래 성공률을 높이기 위해 독점 광고 부스를 즐길 수 있습니다",
            tijiaoziliao: "판매자 인증 정보 제출",
            place: "준비된 가맹점 인증 정보를 플랫폼에 업로드하고 제출해주세요",
            tijiao: "비즈니스 확인 검토가 제출되었습니다.",
            tijiaosuc: "축하합니다! 귀하의 비즈니스 인증 검토가 통과되었습니다.",
            tijiaofail: "죄송합니다. 비즈니스 인증 검토 실패",
            zhuxiaotijiao: "비즈니스 취소 신청서가 제출되었습니다",
            shenhefail: "비즈니스 취소 신청 검토 실패",
            shenhesuc: "귀하의 비즈니스 취소 신청 검토가 통과되었습니다.",
            shangjiazhuxiao: "사업 취소",
            shenheshibai: "감사 실패",
            shenagain: "재검토",
            sheqinggain: "다시 적용",
            reason: "이유",
            shenqingtuibao: "항복 신청",
            getquan: "다음 권한이 있습니다.",
            read: "나는 읽고 동의합니다",
            lijishenqing: "즉시 신청",
            tips: "신속한",
            wufachexiao: "사업 등록을 취소하는 중입니다. 신청서 제출을 확인한 후에는 취소 할 수 없습니다.",
            suredo: "이 작업을 수행 하시겠습니까?",
            shuzizichan: "디지털 자산 거래 증명서",
            gerenzichan: "개인 디지털 자산 증명",
            second: {
                line: "상인 신청 방법은?",
                step1: "1 단계 : 필요에 따라 비즈니스 애플리케이션 자료 준비",
                step1c1: "다음 응용 자료 준비 :",
                step1c2: "휴대 전화 번호, WeChat ID, QQ 번호, 개인 디지털 자산 인증서 (사진), 디지털 자산 거래 인증서 (사진)",
                step2: "2 단계 : 신청서 제출",
                step2c: "입력 및 업로드해야하는 판매자 인증 검토 정보를 작성하고 검토를 위해 제출을 클릭하십시오.",
                step3: "3 단계 : 데이터 검토",
                stepc: "영업일 기준 3 ~ 5 일 이내에 심사를하겠습니다. 심사 상태는 언제든지 제출 페이지에서 확인할 수 있습니다. 심사를 통과하면 법정 통화 거래 영역에 광고를 게시 할 수 있습니다.",
                agree: "동결 동의",
                agreec: "상인 예금으로",
                shenqingchngweishangjia: "상인 신청",
            },
            yuanyin: "이유",
            tijiaoshenqing: "지원서 제출",
            bizhong: "마진 통화",
            shuliang: "마진 수량",
            chosen: "통화 선택",
            seat: '독점 부스',
            service: '일대일 서비스',
            lowfee: '더 낮은 취급 수수료',
            phone: '전화',
            balance: '개인 자산 상황',
            cardphoto: '신분증 앞뒤 사진',
            wx: '위챗',
            exchange: '디지털 자산의 장외 거래에 참여한 적이 있습니까?',
            handphoto: '증명 사진 소지자',
            qq: 'QQ',
            ploy: '해당하는 위험 통제 전략이 있는가',
            agreement: ' "인증 된 판매자 계약"',
            applyfor: '신청 확인',
            sendcode: '인증 코드 보내기',
            confirm: '결정',
            prepare: '재료 준비',
            review: '리뷰 제출',
            result: "결과를 기다리는 중",
            passed: '시험 통과',
            approve: '인증 가맹점 계약에 동의하세요',
            emailtip1: '다음 자료를 이메일로 보내주세요',
            emailtip2: '가능한 한 빨리 신청서를 검토하겠습니다. ',
        },
        extension: {
            title1: '스폰서 링크',
            title2: '친구 홍보',
            title3: '나의 커미션',
            linkdesc: '다음 URL은 외부 홍보를위한 귀하의 주소입니다. 친구, QQ, WeChat, Weibo, 블로그, 포럼 또는 귀하의 웹 사이트를 통해 홍보 할 수 있습니다.이 주소를 통해 방문하는 모든 사람은 등록 후 귀하의 소유가됩니다. 사용자 및 해당 사용자가이 사이트에서 전략을 제출하면 커미션을받을 수 있으며, 자세한 프로모션 상태는 방문 기록에서 볼 수 있습니다. ',
            linktitle: '귀하의 프로모션 링크',
            copy: '부',
            copy_msg1: '복사 성공! ',
            copy_msg2: '복사 실패! 수동으로 복사하십시오 ',
            username: '사용자 이름',
            currrecharge: '현재 거래',
            userlevel: '권장 레벨',
            createdtime: '등록 시간',
            currcommission: '현재 커미션',
            managerfee: '관리비',
            yuan: '원',
            symbol: '통화',
            amount: '양',
            remark: '비고',
            amounttime: '발급 시간',
        },
        promotion: {
            title: "내 승진",
            subtitle1: "내 프로모션 카드",
            subtitle2: "교환 기록",
            subtitle3: "내 초대장",
            card_column0: "사용 코드",
            card_column1: "카드 이름",
            card_column2: "카드 통화 유형",
            card_column3: "카드 금액",
            card_column4: "유효 기간",
            card_column5: "합계",
            card_column6: "사용됨",
            card_column7: "수집 시간",
            my_column0: "사용자 초대",
            my_column1: "등록 시간",
            my_column2: "실명 현황",
            gopromotion: "홍보 자료",
            inputcardno: "사용 코드를 입력하세요",
            exchange: "지금 교환",
            exchangesuccess: "교환이 성공했습니다! 자산 관리로 가서 잔액을 확인하세요!",
            exchangewithcode: "코드 교환"
        },
        activity: {
            navTitle: "혁신 관리",
            subNavTitle1: "참여했다",
            subNavTitle2: "내 마이닝 머신",
            subNavTitle3: "잠금 위치",
            column1: "이름",
            column2: "유형",
            column3: "구독 수량",
            column4: "참여 통화",
            column5: "구독 단위",
            column6: "현재 상태",
            column7: "거래 금액",
            column8: "생성 된 시간",
            mColumn1: "광산 기계",
            mColumn2: "이름",
            mColumn3: "통화",
            mColumn4: "주기",
            mColumn5: "일",
            mColumn6: "굴착",
            mColumn7: "상태",
            mColumn8: "기본 용량",
            mColumn9: "현재 용량",
            mColumn10: "총 산출량",
            mColumn11: "종료일",
            mColumn12: "만든 날짜",
            lColumn1: "위치 잠금",
            lColumn2: "이름",
            lColumn3: "통화",
            lColumn4: "주기",
            lColumn5: "일",
            lColumn6: "출시",
            lColumn7: "상태",
            lColumn8: "기본 용량",
            lColumn9: "현재 용량",
            lColumn10: "총 산출량",
            lColumn11: "종료일",
            lColumn12: "만든 날짜",
        },
        mining: {
            title: "내 마이닝 머신 목록",
            empty: "일시적으로 채굴 기계 없음",
            day: "일",
            week: "주",
            month: "달",
            year: "년",
            invitetip1: "이 광산 기계의 생산 능력은 친구를 초대하여 증가시킬 수 있습니다. 누군가가 광산 기계로 교환하도록 초대 될 때마다 생산 능력이 증가 할 것입니다",
            invitetip2: "%, 용량 증가 상한",
            miningUnit: "출력 통화",
            miningPeriod: "생산주기",
            miningDays: "채굴 시간",
            miningedDays: "마인드 타임",
            miningDaysProfit: "기본 용량",
            miningCurrentDaysProfit: "실제 용량",
            status0: "배포 예정",
            status1: "배포 됨",
            status2: "위에"
        },
        locked: {
            title: "잠긴 위치 목록",
            empty: "잠금 없음",
            day: "일",
            week: "주",
            month: "달",
            year: "년",
            invitetip1: "이 락업의 용량은 친구를 초대하여 늘릴 수 있으며, 락업에 참여하도록 초대받은 사람은 각각 용량을 증가시킬 것입니다.",
            invitetip2: "%, 용량 증가 상한",
            miningUnit: "출시 통화",
            miningPeriod: "릴리스 사이클",
            miningDays: "총 출시 기간",
            miningedDays: "출시 기간",
            miningDaysProfit: "기본 릴리스",
            miningCurrentDaysProfit: "실제 출시",
            status0: "발매 예정",
            status1: "해제",
            status2: "위에",
            totallocked: "총 잠금"
        },
        api: {
            apiAdmin: "API 관리",
            createApi: "새 API 키 생성",
            mark: "API 노트",
            bindAddress: "승인 된 IP (승인 된 IP 주소에 유효한 키는 90 일)",
            hint: '신속한',
            part1: "시장 조회, 자동 거래 등의 서비스를 이용할 수있는 강력한 API를 제공합니다. Pass",
            apiDoc: "API 문서",
            howUse: "사용 방법보기",
            part2: "각 사용자는 최대 5 개의 API 키를 생성 할 수 있습니다.",
            part3: "자산 손실을 방지하려면 API 키를 공개하지 마십시오. 보안상의 이유로 IP를 API 키에 바인딩하는 것이 좋습니다. 각 API 키는 최대 5 개의 IP에 바인딩됩니다. 단일 주소를 직접 입력하고 여러 IP 주소에 쉼표를 사용하십시오. 구분됨 (예 : 192.168.1.1,192.168.1.2,192.168.1.3. ",
            myApiKey: "내 API 키",
            ipAddress: "IP 주소",
            createTime: "생성 된 시간",
            accessKey: "액세스 키",
            bindIpAddress: "IP 주소 바인딩",
            ioDays: "남은 유효 기간 (일)",
            operation: "운영 중",
            create: "창조하다",
            edit: "편집하다",
            delete: "지우다",
            sureDelete: "삭제 확인",
            tips: "키가 추가 된 경우에만 표시됩니다. 시간 내에 저장하십시오",
            copy: "부",
            access: "키",
            okText: "확인",
            cancel: "취소"
        }
    },
    cms: {
        noticecenter: '공지 센터',
        newshelp: '새로운 손길',
        appdownload: '앱 다운로드',
        onlineservice: '온라인 서비스',
        faq: '일반적인 문제',
        notice: '발표',
        servicecenter: '고객 서비스',
        about: '의 위에',
        joinus: '우리와 함께',
        aboutus: '우리에 대해',
        exchangerule: '거래 규칙',
        useprotocol: '이용 동의',
        feenote: '충전 설명',
        merchantprocotol: '판매자 계약',
        features: "플랫폼 기능",
        contactus: "문의하기",
        noticelist: '공지 목록',
        nextnotice: '다음',
        prevnotice: "이전",
        notexist: "방문하신 공지 사항이 존재하지 않거나 삭제되었습니다!",
        otherhelp: "이 카테고리의 기사",
        scanforshare: "공유하려면 스캔",
        download: "즉시 다운로드",
        downloadslogan: "BIPPAX APP- 글로벌 디지털 자산 거래 플랫폼"
    },
    description: {
        // message1:'SSL, 동적 신원 확인 및 기타 은행 수준 보안 기술, \ n 거래 보안 보장, 여러 디지털 통화 거래 지원',
        // message2:'플랫폼 사용자의 이익을 보장하기위한 엄격한 프로젝트 진입 장벽; \ n100 % 예금, 지갑은 사용자 자금의 안전을 보장하기 위해 뜨겁고 차가운 상태에서 격리됩니다.',
        // message3:'BIPPAX 디지털 자산 거래 플랫폼은 초당 1000 건의 거래를 지원하여 사용자에게 풍성한 거래 경험을 제공합니다 \ n',
        title1: '금융 등급 보안',
        title2: '빠른 입출금',
        title3: '글로벌 서비스',
        title4: '강하게 선택된 자산',
        message1: '전방적인 금융 리스크 관리 시스템 및 도난 방지 시스템, 온 / 냉 지갑, 자금 안전 확보를위한 다중 서명 시스템',
        message2: '최대한 투자 기회를 놓치는 고객을 보호하기 위해 24 시간 수동 온라인 검토, 최대한 빨리 3 분 안에 재충전 및 출금 완료 가능',
        message3: '글로벌 암호화 자산에 투자하고 글로벌 사용자와 거래 할 수있는 글로벌 비즈니스 서비스 네트워크 커버리지',
        message4: '고품질 암호화 프로젝트를 엄격하게 선택하고 위험도가 매우 높은 프로젝트의 80 %를 필터링합니다.',
        message5: 'BIPPAX (www.bippaxcoins.com) 국제 디지털 암호화 자산 거래 플랫폼 모바일 클라이언트, 핸드 헬드 거래 경험 중심',
        scanqrcode: "QR 코드를 스캔하고 APP 다운로드",
        aboutdesc1: "BIPPAX (www.bippaxcoins.com)은 케이맨 제도에 등록 된 세계 최고의 디지털 자산 거래 플랫폼이며 핵심 운영 팀은 홍콩에 있습니다. BIPPAX (www.bippaxcoins.com)의 핵심 구성원은 최고의 인터넷 및 금융 회사에서 왔습니다. , 대부분의 회원들은 비트 코인과 블록 체인에 대한 깊은 신념을 가지고 있습니다. 우리는 블록 체인이 전통적인 독점 금융 시스템을 변화시키고보다 민주적이고 자율적 인 사회 구조를 구축 할 것이라고 확신합니다. ",
        aboutdesc2: "BIPPAX (www.bippaxcoins.com) 플랫폼은 전문적인 재무 수준의 트랜잭션 구조와 자체 개발 한 고 동시성 메모리 매칭 트랜잭션 엔진을 갖추고 있습니다.이 플랫폼은 완전히 콜드 충전 지갑 시스템 + 다중 서명 + 높은 보호 DDOS 공격 시스템 및 기타 트랜잭션 구조를 채택합니다. 고객 자산의 안전을 보장합니다. ",
        aboutdesc3: "BIPPAX (www.bippaxcoins.com) 고객이 투자 기회를 더 잘 파악할 수 있도록 고객 서비스 부서는 내부적으로 평면 관리를 채택하고 매우 빠른 서비스 응답 메커니즘을 구축했습니다. 자산 고객 서비스 관리자는 고객에게 자산 입금 및 인출을 제공하기 위해 연중 무휴 24 시간 내내 온라인 상태를 유지합니다. 고객이 25 분 이내에 자산 입금 및 인출을 완료 할 수 있도록하는 기타 서비스도 있습니다. ",
        aboutdesc4: "BIPPAX (www.bippaxcoins.com)은 고품질 프로젝트를 엄격하게 선별하고 안전하고 안정적인 자산 보관 서비스를 제공합니다. BIPPAX (www.bippaxcoins.com)은 '정직, 공정성, 열정 및 개방성' 이라는 개념을 고수하며 안전하고 신뢰할 수 있으며 효율적이고 친근한 최고의 교환입니다. ",
        aboutdesc5: "디지털 자산은 이제 작은 원 안에 있지만 누구나 완전히 통제 할 수있는 이러한 자산은 앞으로도 인기가있을 것이라고 믿습니다. 열심히 노력하고 기대하겠습니다!",
        support: "기술적 지원",
        report: "제안",
        service: "고객 서비스",
        apply: "상장 신청",
        coop: "비즈니스 협력",
        community: "비얀 커뮤니티",
        wechat: "위챗",
        addwechat: "'bmate601' 을 WeChat 친구로 추가하고 WeChat 복지 커뮤니티에 들어가십시오",
        weibo: "웨이 보",
        twitter: "트위터",
        biyong: "통화",
        telegram: "전신",
        medium: "매질",
        reddit: "레딧"
    },
    bzb_description: {
        title1: "배당 권",
        title2: "취급 수수료 할인",
        title3: "우선 구독",
        title4: "선거권",
        title5: "알 수있는 첫 번째 권리",
        title6: "우선 순위 목록",
        title7: "함께상의하고 결정을 내리십시오",
        title8: "더",
        desc1: "취급 수수료 배당금, 소득 배당금, 통화 상장 배당금, 주식 배당금 등",
        desc2: "거래 수수료는 최대 80 % 할인되며 보상금은 환불됩니다. 세부 사항은 추후 결정됩니다.",
        desc3: "First IEO 및 Boot Promotion Token Priority Subscription Rights",
        desc4: "상장, 재구매 등을 포함하되 이에 국한되지 않는 BIPPAX 커뮤니티 투표 활동에 참여하십시오.",
        desc5: "일정량의 미결제 약정이 SVIP 그룹에 들어가고 빅 V와 거리가 0이 될 것입니다.",
        desc6: "상장 추천 자격이있는 슈퍼 노드 만",
        desc7: "슈퍼 노드 만이 주요 결정을 논의 할 권리가 있습니다",
        desc8: "더 많은 권리, 계속 지켜봐주십시오"
    },
    footer: {
        wechatkefu: "WeChat 고객 서비스",
        notice: '플랫폼 발표',
        changjian: '일반적인 문제',
        shiyong: '이용 동의',
        feilv: '요금 설명',
        lianxi: '이메일 연락처',
        biyong: '코인 사용',
        gsmc: '글로벌 프리미엄 디지털 자산 교환',
        bah: '상하이 ICP 번호 13026899-3',
        gsjj: '의 위에',
        gywm: '우리에 대해',
        jrwm: '우리와 함께',
        lxwm: '문의하기',
        yqlj: '연결',
        bzzx: '지원 센터',
        xsrm: '초보자 튜토리얼',
        czzn: '충전 가이드',
        ptsm: '플랫폼 설명',
        fysm: '거래 규칙',
        fwtk: '사용자 동의',
        fltk: '충전 설명',
        wechat: "WeChat 고객 서비스",
        xszn: "초보자 안내서",
        cjwt: "일반적인 문제",
        mztk: "부인 성명",
        ystk: "개인 정보 정책",
        tkxy: "약관 동의",
        gybzb: "BZB 정보",
        kfyx: "고객 서비스 이메일",
        swhz: "비즈니스 협력",
        sbsq: "상장 신청",
        jyzn: "거래 가이드",
        bzzl: "통화 정보",
        tsjb: "불만",
        apidoc: "API 인터페이스",
        zwkf: "아직 열리지 않음"
    },
    index: {
        circulation: "BHB 보안 및 개발 기금 순환",
        hourEth: '오늘 배분할 총소득이 환산된다',
        yesterdayEth: '어제 누적 소득 분배 환산',
        yesterday: '어제 채굴량',
        bhbTotal: "BHB 총 유통량",
        bhbSecond: "BHB 유통 시장 유통",
        checkMineprinciple: "채굴 원리보기",
        checkFlowVolum: '유동성 설명 확인',
        checkLockPosition: '잠긴 위치보기',
        BHBregister: "BIPPAX 계정 등록",
        tibi: "출금 도착 시간 및 제한",
        line_plane: "BHB 출시 계획, 유통 및 수수료 환급 안내",
        fenpeijizhi: 'BIPPAX 소득 분배 메커니즘에 대한 설명',
        jiangli_jihua: "초대 채굴 보상 프로그램",
        friend_fanhuan: "친구 초대 및 추가 수수료 환불"
    },
    plate: {
        title: "플랫폼 소득 분배 계획 (BHB 보유자 지분)",
        content1: "백서에 설명 된대로 BIPPAX는 플랫폼 수입의 80 % (세금 및 수수료 후)를 BIPPAX 보유자에게 할당하고 수입의 20 %는 플랫폼의 R & D 및 운영을 지원하는 데 사용됩니다.",
        content2: "소득 분배는 하루를 분배 주기로하고 2018 년 6 월 6 일이 첫 분배 일입니다. 그 후 매일 전날 분배 될 모든 수입이 BHB 보유자에게 일회성 비례 적으로 분배됩니다",
        content3: "(참고 : 1. 여기서 BHB는 출시 / 유통 된 BHB만을 의미합니다. [",
        content3_1: 'BHB 유통 / 소득 분배율 참여 설명',
        content3_2: "2. 매시간 (정시) 스냅 샷을 찍고 한 번 계산하면 하루에 한 번 소득 분배가 이루어집니다.",
        hourFenpei: "오늘의 분배 소득 상당",
        hourTotal: '오늘의 총 플랫폼 수익 상당',
        xiangqing: '오늘의 소득 분배 내역',
        yesterdaytit: "어제의 일일 분배 소득 상당",
        yesterdaytotal: "어제의 총 플랫폼 수익 상당",
        yesterdayxiangqing: "어제 소득 분배 내역",
        /*yesterday:{
          total:"총 플랫폼 수수료",
          allocated:"배분 될 소득",
        }*/
    },
    feereturn: {
        ruletitle: "반품 규칙",
        rulecontent: "BHB의 분배 비율은 백서에 자세히 설명되어 있습니다. BHB의 51 %는 '트랜잭션은 채굴' 방식을 통해 거래 사용자에게 점진적으로 보상됩니다. BHB의 51 %가 완전히 보상되면 '채굴' 은 자동으로 종료됩니다. . ",
        recordtitle: '반품 기록',
        recordcontent: '일일 (UTC + 8, 아래 동일)은 전날 사용자가 부담 한 거래 수수료 100 %를 BHB로 환산하여 사용자에게 반환합니다. 환산 가격은 전 거래일 BHB 평균 가격을 기준으로합니다. 총 거래 금액 / 총 거래량). 매일 오전 11시에 전날 거래 수수료의 BHB 환급을 시작합니다. ',
        /* time:"데이트",
        todaycharge:"당일 BIPPAX 평균 가격 (ETH)",
        totalChange:'당일 총 취급 수수료 (ETH)',
        returnCharge:"당일 채굴 료 환불 (BHB)",
        todayChargeReturn:"당일 채굴 소득 이중 계획 반환 (BHB)" */
    },
    home: {
        login: {

            title: '코인 거래 열기',

            desc: '500+ 코인 및 다양한 거래 도구 지원',

            btnText: '거래하러 가기'

        },

        unlogin: {

            title: '너의 디지털 화폐 여행을 시작해',

            desc: '등록향신인복지선물 세트',

            placinfo: '핸드폰/메일박스',

            btnText: '등록'

        },

        WelfareCenter: '복지센터',

        Welcome_ceremony: '새해맞이 선물',

        Airdrop: '필수 에어드롭',

        DailyGain: '일일득',

        AirdropGift: '공투선물',

        financial_management: '우선 재테크·',

        Zhoude: '주주득',

        height_is: '높이',

        Happiness: '오복카니발·',

        Monthly: '월월득',

        CarveUp: '분할',

        download: {

            transactions_anytime: '언제 어디서나, 거래 시작',

            scan_code: '코드 스캔 다운로드',

            download_more: '더 다운로드'

        },

        brand: {

            digital_platform: '선도적인 디지털 자산 거래 플랫폼',

            rich_digital: '풍부한 디지털 자산 거래 및 자산 관리 서비스로 다양한 거래 수요를 충족시킨다',

            High_quality_digital: '양질의 디지털 자산',

            Turnover: '거래량',

            safety_risk: '세계 최고의 안전 바람 제어 시스템',

            multi_factor: '오프라인 저장 방식, 다중 요소 암호화 수단, 7일 24시간 연중무휴 플랫폼 모니터링, 사용자 자산 보호 전방위적',

            Security_reserve: '안전장치금',

            accident: '9년 0사고',

            safetyrisk: '최고의 안전 바람 제어',

            choice_trusted: '천만 사용자 신뢰 선택',

            transaction_서비스: '전 세계 여러 국가 지역에 현지화된 거래 서비스 센터를 설립하여 다양한 업무 형태가 일체화된 블록체인 생태계를 조성한다',

            ten_thousand: '만',

            User_preference: '사용자 선호',

            Countries_covered: '국가 덮어쓰기'

        },

        trading: {

            digital_currency: '너의 디지털 화폐 여행을 시작해',

            register: '등록',

            login: '로그인',

            currency_transaction: '코인 거래 열기',

            to_trade: '거래하러 가기'

        }
    }

}



// WEBPACK FOOTER //
// ./src/assets/lang/ko/index.js